// Dashboard Component is the place to position all graphs from within a tab
// graph from each tile can be selected to render here
// The dimensions of Graph area can be set to Full width or any other custom aspect ratio

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { FormControl, Select, MenuItem, IconButton, Divider } from '@mui/material';

import { useSelector } from 'react-redux';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {
  callQueryAPIDashboard,
  toggleDashMode,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { toggleDashModeInTab, toggleMouseOverInteractivity } from '../../redux/TabTile/TabActions';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useCallback } from 'react';
import {
  resetGraphHighlight,
  updateGraphHighlight,
  updateTabDashDetails,
} from '../../redux/TabTile/TabActions';
import { setDashGridSize } from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { toggleGraphSize } from '../../redux/TabTile/TileActions';
import './DashBoard.css';
import { DashBoardProps, DashBoardStateProps } from './DashBoardInterfaces';
import DashBoardLayoutControl from './DashBoardLayoutControl';
import GraphRNDDash from './GraphRNDDash';
import { Box, Checkbox, Tooltip } from '@mui/material';
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';
import jsPDF from 'jspdf';
import { toPng } from 'html-to-image';
import { resetPageSettings } from '../../redux/PageSettings/DownloadPageSettingsActions';
import ChartFilterGroupsContainer from '../ChartFilterGroup/groupsContainer/ChartFilterGroupsContainer';
import ChartData from '../ChartAxes/ChartData';
import { ColorSchemes } from '../ChartOptions/Color/ColorScheme';
import ChartColors from '../ChartOptions/Color/ChartColors';
import SwitchWithInput from '../ChartOptions/SwitchWithInput';
import { useDispatch } from 'react-redux';
import ImageUploadModal from './ImageUploadModal';
import Image from './Image';
import ParameterContainer from '../Parameters/ParameterContainer';
import DashboardObjects from './DashboardObjects';
import { RootState } from '../../redux';
import LaunchIcon from '@mui/icons-material/Launch';
import WindowIcon from '@mui/icons-material/Window';

import {
  setTheme,
  setDashColorScheme,
  setThemeId,
  toggleAllTiles,
  toggleAllTabs,
  toggleThemeState,
  setSelectedImageId,
} from '../../redux/TabTile/TabActions';

import { actionsToUpdateSelectedTile } from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';

import {
  updateDashBoardGroups,
  deleteDashBoardSelectedGroup,
  addDashBoardFilterGroupTabTiles,
  setDashBoardFilterGroupsTabTiles,
  deleteDashBoardSelectedGroupAllTabTiles,
  deleteDashBoardSelectedTabTiles,
  updateDashBoardSelectedTabTiles,
} from '../../redux/DashBoardFilterGroup/DashBoardFilterGroupAction';
import {
  updateDashGraphPosition,
  updateDashGraphSize,
  updateImageSize,
  setHoveredTile,
  clearHoveredTile,
  setSelectedTile,
  setAllTileBorder,
  updateAllTileBorder,
  removeAllTileBorder,
  setFontFamily,
  setFontFamilyForAllTiles,
  setTilesColorSchemeToDashboardScheme,
  updateRichTextElement,
  resetCustomLayout,
} from '../../redux/TabTile/TabActions';
import {
  setResolutionType,
  setResolution,
  setAutoScalingWidth,
  setAutoScalingHeight,
  setDashboardHeight,
  setFilterVisibilityMode,
  setFilterPanelMode,
  setDashboardRows,
} from '../../redux/TabTile/TabActions';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Logger from '../../Logger';
import { actionsToSelectTab } from '../../redux/TabTile/actionsTabTile';
import { Editor } from 'slate';
import {
  setColorScaleOption,
  setColorScheme,
  setTileThemeId,
  setManualColorGauge,
  updateGeoChartStyleOptions,
  updateSankeyStyleOptions,
  updatePieChartStyleOptions,
  updateDoughChartStyleOptions,
  updateRoseChartStyleOptions,
  updateAreaChartStyleOptions,
  updateLineChartStyleOptions,
  updateHorizontalBarChartStyleOptions,
  updateBarChartStyleOptions,
  updateHorizontalStackedBarChartStyleOptions,
  updateStackedAreaChartStyleOptions,
  updateStackedBarChartStyleOptions,
  updateWaterfallChartStyleOptions,
  updateFunnelChartStyleOptions,
  updateScatterChartStyleOptions,
  updateTreeMapStyleOptions,
  updateCalendarStyleOptions,
  updateCardControls,
} from '../../redux/ChartPoperties/ChartControlsActions';
import { AcceptRejectDialog } from '../CommonFunctions/DialogComponents';
import { fontSize } from '../..';
import { iconVariants } from './IconVariants';
import Button from './DraggableResizeButton/Button';
import useCombinedColorSchemes from '../../hooks/useCombinedColorSchemes';
import fetchThemeIdByName from '../../hooks/fetchThemeIdByName';
import DownloadPagePopover from '../CommonFunctions/PopOverComponents/DownloadPagePopover';
import RichText from './RichText/RichText';
import BorderControles from './BorderControle';
import ChartControlObjects from '../ChartOptions/ChartControlObjects';
import '../../Components/ChartOptions/ChartOptions.css';
import { FontFamilies } from '../../types/FontFamilies';
import { OrientationRadioGroup } from '../ChartOptions/Legend/LegendComponents/OrientationRadioGroup';
import useDashboardClipboard from './useDashboardClipboard';
import { Radio } from '@mui/material';
import { chartTypes } from '../ChartOptions/ChartTypeComponents/chartTypes';
import useThemeAdjustment from './useThemeAdjustment';

const DashBoard = ({
  // props
  showListofTileMenu,
  dashboardResizeColumn,
  showDashBoardFilterMenu,
  iconAlign,
  setShowListofTileMenu,
  setDashboardResizeColumn,
  setShowDashBoardFilter,

  showObjectsSidebar,
  setShowObjectsSidebar,
  setShowDashBoardFilterEdit,

  reportFilterMenu,
  setReportFilterMenu,
  parameterMenu,
  setParameterMenu,
  showDashboardFilterEdit,
  setShowDashboardFilterEdit,

  setMapJSON,
  setLoading,

  tabAreaBackgroundColor,
  iconColor,
  selectedTabBackgroundColor,

  // state
  chartGroup,
  dashBoardGroup,
  tabState,
  tabTileProps,
  tileState,
  pageSettings,
  chartControls,
  playBookId,
  // dashboardBgImage,
  chartProperties,

  //ColorSchemes,

  // dispatch
  selectTab,
  setTheme,
  selectTile,
  toggleAllTabs,
  toggleAllTiles,
  toggleThemeState,
  setDashColorScheme,
  setThemeId,
  updateDashDetails,
  resetCustomLayout,
  toggleGraphSize,
  setGridSize,
  graphHighlight,
  resetHighlight,
  resetPageSettings,
  updateCardControls,
  updateSankeyStyleOptions,
  updateGeoChartStyleOptions,
  setColorScaleOption,
  setManualColorGauge,
  updateDashBoardGroups,
  deleteDashBoardSelectedGroup,
  addDashBoardFilterGroupTabTiles,
  setDashBoardFilterGroupsTabTiles,
  deleteDashBoardSelectedGroupAllTabTiles,
  deleteDashBoardSelectedTabTiles,
}: DashBoardProps) => {
  var targetRef = useRef<any>();
  const dispatch = useDispatch();

  const selectedTab = tabTileProps.selectedTabId;
  const { hoveredTileKey, selectedTileKey } = tabState;
  const [activeEditor, setActiveEditor] = useState<Editor | null>(null);
  const [editorChangeCounter, setEditorChangeCounter] = useState(0);
  const handleEditorChange = useCallback(() => setEditorChangeCounter((c) => c + 1), []);
  const dashTheme = tabState.tabs[selectedTab]?.dashboardState?.colorScheme;
  const selectedFontFamily = tabState.tabs[selectedTab]?.dashboardState?.fontFamily;
  const tilesTodashboard = tabState.tabs[selectedTab]?.dashboardState?.tilesTodashboard;
  const fontFamilyForAllTiles = tabState.tabs[selectedTab]?.dashboardState?.fontFamilyForAllTiles;
  const { filterVisibilityMode, filterPanelMode } = tabState.tabs[selectedTab]?.dashboardState;

  const scheme_passed = dashTheme ?? 'peacock';
  const prevSchemeRef = useRef(scheme_passed);
  const prevTab = useRef(selectedTab);
  const prevTilesLen = useRef(tabState.tabs[selectedTab]?.tilesInDashboard?.length || 0);
  const prevImagesLen = useRef(
    tabState.tabs[selectedTab]?.dashboardObjects?.imageElements?.length || 0,
  );
  const prevTextLen = useRef(
    tabState.tabs[selectedTab]?.dashboardObjects?.richTextElements?.length || 0,
  );
  const [mouseDownOutsideGraphs, setmouseDownOutsideGraphs] = useState<boolean>(false);
  const [dimensions, setDimensions] = useState<any>({});
  const theme = tabState.tabs[selectedTab]?.dashboardState?.theme
    ? tabState.tabs[selectedTab]?.dashboardState?.theme
    : 'FlatUI';
  const color_scheme = tabState.tabs[selectedTab]?.dashboardState?.colorScheme
    ? tabState.tabs[selectedTab]?.dashboardState?.colorScheme
    : 'peacock';

  const [innerDimensions, setinnerDimensions] = useState<any>({});
  const [softUI, setSoftUI] = useState<boolean>(theme === 'SoftUI');

  const [schemeColor, setSchemeColor] = useState<string>(scheme_passed);
  const [fullScreen, setFullScreen] = useState<boolean>(false);

  const ApplytoAllTabs = tabState.tabs[selectedTab]?.dashboardState?.allTabs || false;
  const ApplytoTiles = tabState.tabs[selectedTab]?.dashboardState?.allTiles || false;
  const [isOverrideWarning, setIsOverrideWarning] = useState<boolean>(false);
  const [isOverrideTile, setIsOverrideTile] = useState<boolean>(false);
  const ThemeState = tabState.tabs[selectedTab]?.dashboardState?.themeState;
  const [applyThemeAcrossPlaybook, setApplyThemeAcrossPlaybook] = useState<boolean>(ThemeState);
  const applyBorder = tabState.tabs[selectedTab]?.allTileBorder?.isBorder;
  const existingBorder = tabState.tabs[selectedTab]?.allTileBorder?.borderProperties;
  const mouseOverInteractivity =
    tabState.tabs[selectedTab]?.interactivity?.mouseOverInteractivity || false;

  const prevApplyToTilesRef = useRef(ApplytoTiles);
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedObject, setSelectedObject] = useState<string | null>(null);
  const [layerMode, setLayerMode] = useState<'tiles' | 'objects'>('tiles');
  const [isTilesCollapsed, setIsTilesCollapsed] = useState<boolean>(false);
  const [interactingTile, setInteractingTile] = useState<string | null>(null);

  const iconMap: { [key: string]: { filled: React.ReactNode; outlined: React.ReactNode } } = {};
  iconVariants.forEach((icon) => {
    iconMap[icon.type] = { filled: icon.filled, outlined: icon.outlined };
  });

  const resolutionSettings = tabState.tabs[selectedTab]?.resolutionSettings;
  const [selectedOption, setSelectedOption] = useState('theme');
  const [heightAdjustment, setHeightAdjustment] = useState<number>(1); // default step value

  const {
    dashboardHeight = 0,
    resolutionType = 'autoWidth',
    resolution = '',
    autoScalingWidth = '',
    autoScalingHeight = '',
    dashboardRows = 32,
  } = resolutionSettings || {};

  const getMinDashboardHeight = () => {
    const minRatio = 0.6; // 60% of screen height
    return Math.max(window.innerHeight * minRatio, 180);
  };

  const isSilzilaTheme = (themeName: string) => {
    const silzilaThemes = ColorSchemes.map((theme) => theme.name); // assuming ColorSchemes is available
    return silzilaThemes.includes(themeName);
  };

  //function to get all elements count
  const getDashboardElementCount = (tabId: number) => {
    const tab = tabState.tabs[tabId];
    const imageAndButtonCount = tab?.dashboardObjects?.imageElements?.length || 0;
    const textElement = tab?.dashboardObjects?.richTextElements?.length || 0;
    const graphCount = tab?.tilesInDashboard?.length || 0;
    return imageAndButtonCount + graphCount + textElement;
  };

  const dashboardElements = getDashboardElementCount(selectedTab);

  const isAnySidebarOpen =
    showObjectsSidebar || showListofTileMenu || dashboardResizeColumn || showDashboardFilterEdit;

  const handleCollapseSidebar = () => {
    setShowListofTileMenu(false);
    setShowObjectsSidebar(false);
    setDashboardResizeColumn(false);
    setShowDashboardFilterEdit(false);
    setShowDashBoardFilter(false);
  };

  const tabId = tabTileProps.selectedTabId;
  const defaultThemeId = useSelector(
    (state: RootState) => state.tabState.tabs[tabId]?.dashboardState.defaultThemeId,
  );
  const combinedThemes = useCombinedColorSchemes();

  useEffect(() => {
    // If there's a dashTheme in the dashboard state, use it
    if (dashTheme) {
      setSchemeColor(dashTheme);
      setDashColorScheme(dashTheme, tabId);

      // Find corresponding theme object from combinedThemes to get additional properties
      const themeObj = combinedThemes.find((t) => t.name === dashTheme);
      if (themeObj && themeObj.themeId) {
        setThemeId(themeObj.themeId, tabId);
      }
    } else if (defaultThemeId && combinedThemes.length > 0) {
      // Otherwise fallback to defaultThemeId
      const defTheme = combinedThemes.find(
        (t) => t.id === defaultThemeId || t.themeId === defaultThemeId,
      );
      if (defTheme) {
        setSchemeColor(defTheme.name);
        setBackgroundColor(defTheme.background);

        setDashColorScheme(defTheme.name, tabId);
        if (defTheme.themeId) {
          setThemeId(defTheme.themeId, tabId);
        }
      }
    }
  }, [dashTheme, defaultThemeId, combinedThemes, tabId]);

  useEffect(() => {
    const currentThemeName = tabState.tabs[selectedTab]?.dashboardState?.colorScheme;

    const updateThemeId = async () => {
      if (currentThemeName) {
        if (isSilzilaTheme(currentThemeName)) {
          // Use colorScheme name directly as themeId for silzila themes
          setThemeId(currentThemeName, selectedTab);
        } else {
          // Fetch themeId for user themes
          const themeId = await fetchThemeIdByName(currentThemeName);
          if (themeId) {
            setThemeId(themeId, selectedTab);
          }
        }
      }
    };

    updateThemeId();
  }, [tabState.tabs[selectedTab]?.dashboardState?.colorScheme, selectedTab]);

  useEffect(() => {
    setSoftUI(theme === 'SoftUI');
    setSchemeColor(color_scheme);
  }, [theme, color_scheme, softUI]);
  const { adjustAllItemsForTheme } = useThemeAdjustment();

  const handleThemeChange = async (newtheme: string) => {
    const wasSoftUI = softUI;
    const isSoftUINew = newtheme === 'SoftUI';

    if (newtheme === 'SoftUI') {
      dispatch(removeAllTileBorder({ tabId }));
    } else {
      const existingProperties = tabState.tabs[tabId]?.allTileBorder?.borderProperties;
      dispatch(
        setAllTileBorder({
          tabId,
          borderProperties: existingProperties || { color: '#cecece', width: 1, borderRadius: 2 },
        }),
      );
    }
    setSoftUI(isSoftUINew);
    setTheme(newtheme, tabTileProps.selectedTabId);

    // Adjust item positions to ensure gaps between touching items
    adjustAllItemsForTheme(tabState, selectedTab);

    const themeName = tabState.tabs[selectedTab]?.dashboardState?.colorScheme;
    if (themeName) {
      if (isSilzilaTheme(themeName)) {
        setThemeId(themeName, selectedTab);
      } else {
        const themeId = await fetchThemeIdByName(themeName);
        if (themeId) {
          setThemeId(themeId, selectedTab);
        }
      }
    }
  }; // Dispatch Redux action };

  useEffect(() => {
    setFullScreen(pageSettings.fullScreen);
  }, [pageSettings.fullScreen]);

  useEffect(() => {
    setApplyThemeAcrossPlaybook(applyThemeAcrossPlaybook);
    // Object.keys(tabState.tabs).forEach((tabkey) => {
    //   toggleThemeState(parseInt(tabkey, 10));
    // });
    if (applyThemeAcrossPlaybook) {
      const currentTheme = tabState.tabs[selectedTab]?.dashboardState?.theme;
      if (currentTheme === 'SoftUI') {
        setSoftUI(true);
        console.log('in both, softui');
      } else {
        setSoftUI(false);
        console.log('in both, flatui');
      }
      Object.keys(tabState.tabs).forEach((tabkey) => {
        setTheme(currentTheme, parseInt(tabkey, 10));
      });
    } else {
      const currentTheme = tabState.tabs[selectedTab]?.dashboardState?.theme;
      if (currentTheme === 'SoftUI') {
        setSoftUI(true);
        console.log('in single,softui');
      } else {
        setSoftUI(false);
        console.log('in single,flatui');
      }
      setTheme(currentTheme, selectedTab);
    }
  }, [softUI]);

  const handleToggleAllTabs = () => {
    const allTabIds = Object.keys(tabState.tabs);

    allTabIds.forEach((tabKey) => {
      const tId = parseInt(tabKey, 10);

      // Ensure "Playbook" mode is ON for every tab
      // If it's already true, we don't need to toggle it unless we are turning it OFF
      const isPlaybookModeAlreadyOn = tabState.tabs[tId]?.dashboardState?.allTabs;
      const isTilesModeOn = tabState.tabs[tId]?.dashboardState?.allTiles;

      if (!isPlaybookModeAlreadyOn) {
        toggleAllTabs(tId);
      }
      //  "Across Current Tab" is OFF for every tab to prevent double selection
      if (isTilesModeOn) {
        toggleAllTiles(tId);
      }
    });
  };
  useEffect(() => {
    // Recalculate background color from current tab's scheme when switching tabs
    const currentTabScheme = tabState.tabs[selectedTab]?.dashboardState?.colorScheme;
    const selectedScheme = allThemes.find((scheme) => scheme.name === currentTabScheme);
    const currentTabBgColor = selectedScheme?.background || '#ffffff';
    setBackgroundColor(currentTabBgColor);

    if (tabTileProps.dashMode === 'Present') {
      setdashStyle1({ ...dashStyle1, background: currentTabBgColor });
    } else if (tabTileProps.dashMode === 'Edit') {
      setdashStyle({
        ...dashStyle,
        backgroundImage: ['dark', 'halloween', 'purplePassion', 'chalk'].includes(schemeColor)
          ? darkbackground
          : dashbackground,
      });
    }

    // Reset any state that might hide buttons
    setSidebarOpen(false);
    setSelectedImageId(selectedTab, null);
    dispatch(setSelectedTile(null));
  }, [tabTileProps.selectedTabId, tabTileProps.dashMode]);

  // Handle Toggle for "Apply to All Tiles"
  const handleToggleAllTiles = () => {
    toggleAllTiles(selectedTab);
  };

  const handleApplyThemeChange = async () => {
    const newApplyTheme = !applyThemeAcrossPlaybook;
    setApplyThemeAcrossPlaybook(newApplyTheme);

    Object.keys(tabState.tabs).forEach((tabkey) => {
      toggleThemeState(parseInt(tabkey, 10));
    });

    const currentTheme = tabState.tabs[selectedTab]?.dashboardState?.theme;
    const themeName = tabState.tabs[selectedTab]?.dashboardState?.colorScheme;

    if (newApplyTheme) {
      if (themeName) {
        const themeId = await fetchThemeIdByName(themeName);
        Object.keys(tabState.tabs).forEach((tabkey) => {
          setTheme(currentTheme, parseInt(tabkey, 10));
          if (themeId) {
            setThemeId(themeId, parseInt(tabkey, 10));
          }
        });
      }
    } else {
      setTheme(currentTheme, selectedTab);

      if (themeName) {
        if (isSilzilaTheme(themeName)) {
          setThemeId(themeName, selectedTab);
        } else {
          const themeId = await fetchThemeIdByName(themeName);
          if (themeId) {
            setThemeId(themeId, selectedTab);
          }
        }
      }
    }
    setSoftUI(currentTheme === 'SoftUI');
  };

  const handleApplyFontToAllChange = () => {
    const newFlagValue = !fontFamilyForAllTiles;
    dispatch(setFontFamilyForAllTiles(tabId, newFlagValue));
  };

  const handleApplyBorder = (checked: boolean) => {
    if (checked) {
      dispatch(
        setAllTileBorder({
          tabId,
          borderProperties: tabState.tabs[selectedTab]?.allTileBorder?.borderProperties ?? {
            color: '#cecece',
            width: 1,
            borderRadius: 2,
          },
        }),
      );
    } else {
      dispatch(removeAllTileBorder({ tabId }));
    }
  };

  const handleToggleMouseOverInteractivity = () => {
    dispatch(toggleMouseOverInteractivity({ tabId }));
  };

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    type: '',
    title: '',
    message: '',
  });

  const handleTilesCheckboxClick = () => {
    if (!ApplytoTiles) {
      setConfirmDialog({
        isOpen: true,
        type: 'TILES',
        title: 'Apply to All Tiles?',
        message: 'This Color Scheme will be applied to all tiles of this tab.',
      });
    } else {
      handleToggleAllTiles();
    }
  };

  const handlePlaybookCheckboxClick = () => {
    if (!ApplytoAllTabs) {
      setConfirmDialog({
        isOpen: true,
        type: 'PLAYBOOK',
        title: 'Apply across Playbook?',
        message: 'This Color Scheme will be applied to all tiles and tabs of this Playbook.',
      });
    } else {
      handleToggleAllTabs();
    }
  };

  const handleConfirmAction = () => {
    if (confirmDialog.type === 'TILES') {
      handleToggleAllTiles();
      if (ApplytoAllTabs) {
        Object.keys(tabState.tabs).forEach((id) => {
          const tId = parseInt(id, 10);
          if (tabState.tabs[tId]?.dashboardState?.allTabs) {
            toggleAllTabs(tId);
          }
        });
      }
    } else if (confirmDialog.type === 'PLAYBOOK') {
      handleToggleAllTabs();

      const currentScheme = scheme_passed;
      Object.keys(tabState.tabs).forEach((tabKey) => {
        const tId = parseInt(tabKey, 10);
        setDashColorScheme(currentScheme, tId);
        tileState.tileList[tId].forEach((propkey) => {
          dispatch(setColorScheme(propkey, currentScheme));
        });
      });
    }
    setConfirmDialog({ ...confirmDialog, isOpen: false });
  };

  const handleCloseDialog = () => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
  };

  const getBoxShadow = (schemeColor: any) => {
    if (schemeColor === 'dark') {
      return '0 0 20px rgba(0,0,0,0.6)';
    } else if (schemeColor === 'chalk') {
      return '0 0 18px rgba(0,0,0,0.4)';
    } else if (schemeColor === 'halloween') {
      return '0 0 15px rgba(0,0,0,0.3)';
    } else if (schemeColor === 'purplePassion') {
      return '0 0 20px rgba(0,0,0,0.5)';
    }
    return '0 0 15px rgba(0,0,0,0.12)';
  };

  const resetOverrides = () => {
    Object.keys(chartControls.properties).forEach((key) => {
      updateCardControls(key, 'manualColor', false);
      updateSankeyStyleOptions(key, 'manualColor', false);
      updateGeoChartStyleOptions(key, 'manualColor', false);
      setColorScaleOption('manualColor', false, key);
      setManualColorGauge(key, false);
    });
  };

  var dashbackground: string = `
  linear-gradient(-90deg, rgba(0, 0, 0, 0.05) 1px, transparent 1px),
  linear-gradient( rgba(0, 0, 0, 0.05) 1px, transparent 1px),
  linear-gradient(-90deg, rgba(0, 0, 0, 0.05) 1px, transparent 1px),
  linear-gradient( rgba(0, 0, 0, 0.05) 1px, transparent 1px)`; //only in light color scheme

  var darkbackground: string = `linear-gradient(-90deg, rgba(204, 204, 204, 0.1) 1px, transparent 1px),
  linear-gradient(rgba(204, 204, 204, 0.1) 1px, transparent 1px),
  linear-gradient(-90deg, rgba(204, 204, 204, 0.1) 1px, transparent 1px),
  linear-gradient(rgba(204, 204, 204, 0.1) 1px, transparent 1px)`; // only in dark color scheme

  const [backgroundColor, setBackgroundColor] = useState<string>('');
  var presentbackground: string = backgroundColor;

  const allThemes = useCombinedColorSchemes();
  useEffect(() => {
    if (!scheme_passed || !allThemes.length) return;

    // the Color Scheme object
    const selectedScheme = allThemes.find((scheme) => scheme.name === scheme_passed);
    if (!selectedScheme) return;
    const themeBgColor = selectedScheme.background;
    //if the Theme has actually changed since the last render
    const hasThemeChanged = prevSchemeRef.current !== scheme_passed;
    const hasApplyToTilesToggledOn = !prevApplyToTilesRef.current && ApplytoTiles;
    //  Update the container state
    setBackgroundColor(themeBgColor);
    // Rich Text Logic
    const richTextElements = tabState.tabs[selectedTab]?.dashboardObjects?.richTextElements || [];
    richTextElements.forEach((el) => {
      //  ALL RichText to match the new theme, even if they were manual.
      if (hasThemeChanged) {
        dispatch(
          updateRichTextElement(selectedTab, el.id, {
            backgroundColor: themeBgColor,
            isBackgroundManual: false, // Reset this so it tracks the theme again
          }),
        );
      }

      //  Respect the manual flag.
      else {
        if (el.isBackgroundManual) return;
        if (el.backgroundColor !== themeBgColor) {
          dispatch(
            updateRichTextElement(selectedTab, el.id, {
              backgroundColor: themeBgColor,
            }),
          );
        }
      }
    });

    if (ApplytoAllTabs) {
      Object.keys(tabState.tabs).forEach((tabkey) => {
        setDashColorScheme(scheme_passed, parseInt(tabkey, 10));
      });
    } else {
      setDashColorScheme(scheme_passed, selectedTab);
    }

    if ((ApplytoTiles || ApplytoAllTabs) && (hasThemeChanged || hasApplyToTilesToggledOn)) {
      tileState.tileList[selectedTab].forEach((propkey) => {
        dispatch(setColorScheme(propkey, scheme_passed));

        const chartType = chartProperties.properties[propkey]?.chartType;

        const resetStandardChart = (action: Function) => {
          dispatch(action(propkey, 'manualColor', false)); // Switch toggle to Auto
          dispatch(action(propkey, 'nodeValuesColors', {})); // Clear specific colors
          dispatch(action(propkey, 'allSeriesColor', '')); // Clear global series color
        };

        switch (chartType) {
          case 'pie':
            resetStandardChart(updatePieChartStyleOptions);
            break;
          case 'donut':
          case 'doughnut':
            resetStandardChart(updateDoughChartStyleOptions);
            break;
          case 'rose':
            resetStandardChart(updateRoseChartStyleOptions);
            break;

          case 'multibar':
            resetStandardChart(updateBarChartStyleOptions);
            break;
          case 'horizontalBar':
            resetStandardChart(updateHorizontalBarChartStyleOptions);
            break;
          case 'horizontalStacked':
            resetStandardChart(updateHorizontalStackedBarChartStyleOptions);
            break;
          case 'stackedBar':
            resetStandardChart(updateStackedBarChartStyleOptions);
            break;
          case 'line':
            resetStandardChart(updateLineChartStyleOptions);
            break;
          case 'area':
            resetStandardChart(updateAreaChartStyleOptions);
            break;
          case 'stackedArea':
            resetStandardChart(updateStackedAreaChartStyleOptions);
            break;

          case 'scatterPlot':
            resetStandardChart(updateScatterChartStyleOptions);
            break;
          case 'funnel':
            resetStandardChart(updateFunnelChartStyleOptions);
            break;
          case 'treeMap':
            resetStandardChart(updateTreeMapStyleOptions);
            break;
          case 'waterfall':
            dispatch(updateWaterfallChartStyleOptions(propkey, 'manualColor', false));
            dispatch(updateWaterfallChartStyleOptions(propkey, 'positiveColor', ''));
            dispatch(updateWaterfallChartStyleOptions(propkey, 'negativeColor', ''));
            dispatch(updateWaterfallChartStyleOptions(propkey, 'totalColor', ''));
            break;
          case 'simplecard':
            updateCardControls(propkey, 'manualColor', false);
            updateCardControls(propkey, 'bgColor', selectedScheme.background);
            updateCardControls(propkey, 'valueColor', selectedScheme.colors[0]);
            updateCardControls(propkey, 'labelColor', selectedScheme.dark ? '#fff' : '#666666');
            break;
          case 'calendar':
          case 'heatmap':
            setColorScaleOption('manualColor', false, propkey);
            setColorScaleOption('minColor', selectedScheme.colors[0], propkey);
            setColorScaleOption('maxColor', selectedScheme.colors[1], propkey);

            if (chartType === 'calendar') {
              const labelColor = selectedScheme.dark ? '#fff' : 'black';
              updateCalendarStyleOptions(propkey, 'dayLabelColor', labelColor);
              updateCalendarStyleOptions(propkey, 'monthLabelColor', labelColor);
              updateCalendarStyleOptions(propkey, 'yearLabelColor', labelColor);
            }
            break;
          case 'sankey':
            updateSankeyStyleOptions(propkey, 'manualColor', false);
            updateSankeyStyleOptions(
              propkey,
              'linkColor',
              selectedScheme.dark ? '#fff' : '#666666',
            );
            updateSankeyStyleOptions(propkey, 'backgroundColor', selectedScheme.background);

            if (chartProperties.properties[propkey].chartAxes[1]?.fields) {
              const values = chartProperties.properties[propkey].chartAxes[1].fields.map(
                (el: any, i: number) => ({
                  nodeName: el.fieldname,
                  nodeColor: selectedScheme.colors[i % selectedScheme.colors.length],
                }),
              );
              updateSankeyStyleOptions(propkey, 'nodesAndColors', values);
            }
            break;
          case 'filledMap':
          case 'bubbleMap':
            updateGeoChartStyleOptions(propkey, 'manualColor', false);
            updateGeoChartStyleOptions(propkey, 'maxColor', selectedScheme.colors[0]);
            updateGeoChartStyleOptions(propkey, 'minColor', selectedScheme.colors[1]);
            updateGeoChartStyleOptions(
              propkey,
              'borderColor',
              selectedScheme.dark ? 'white' : 'grey',
            );
            updateGeoChartStyleOptions(
              propkey,
              'areaColor',
              selectedScheme.tableHeaderBackground || '#fff',
            );

            if (chartType === 'bubbleMap' && chartControls?.geoChartControls?.bgCol) {
              const newBgCol = { ...chartControls.geoChartControls.bgCol };
              let index = 0;
              Object.keys(newBgCol).forEach((key) => {
                newBgCol[key] = selectedScheme.colors[index % selectedScheme.colors.length];
                index++;
              });
              updateGeoChartStyleOptions(propkey, 'bgCol', newBgCol);
            }
            break;
        }
      });
    }
    prevSchemeRef.current = scheme_passed;
    prevApplyToTilesRef.current = ApplytoTiles;
  }, [
    scheme_passed, // Triggers when theme changes
    selectedTab, // Triggers when tab changes
    allThemes,
    ApplytoAllTabs,
    ApplytoTiles,
    tabState.tabs[selectedTab]?.dashboardObjects?.richTextElements,
  ]);

  const handleToggleTilesTheme = () => {
    dispatch(setTilesColorSchemeToDashboardScheme(selectedTab, !tilesTodashboard));
  };

  const [dashStyle, setdashStyle] = useState<any>({
    width: innerDimensions.width,
    height: innerDimensions.height,
    backgroundImage: ['dark', 'halloween', 'purplePassion', 'chalk'].includes(schemeColor)
      ? darkbackground
      : dashbackground,
  });

  const [dashStyle1, setdashStyle1] = useState<any>({
    width: innerDimensions.width,
    height: innerDimensions.height,
    backgroundColor: presentbackground,
  });

  const [style, setStyle] = useState<any>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'solid 1px transparent',
    backgroundColor: 'white',
    boxSizing: 'border-box',
    zIndex: 10,
  });

  const [style2, setStyle2] = useState<any>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'solid 1px darkGray',
    backgroundColor: 'white',
    boxSizing: 'border-box',
    zIndex: 20,
  });

  const skeuomorphicStyle = {
    /*boxShadow: "8px 8px 15px rgba(0,0,0,0.15), -8px -8px 15px rgba(255,255,255,0.8)",*/
    //backgroundColor: backgroundColor,
    // borderRadius: "12px",
  };
  const tileskeuomorphicStyle = {
    boxShadow: getBoxShadow(schemeColor), // backgroundColor is dynamically passed
    borderRadius: '12px',
  };

  const skeuomorphicInnerStyle = {
    boxShadow: 'inset 4px 4px 8px rgba(0,0,0,0.2), inset -4px -4px 8px rgba(255,255,255,0.7)',
    //backgroundColor: backgroundColor,//"#EEF0F7",//f3f3f3
    borderRadius: '8px',
  };

  const getHeightAndWidth = (paperHeight: number, paperWidth: number) => {
    var graphHeight = dashStyle.height;
    var graphWidth = dashStyle.width;
    const pageHeight = paperHeight - (pageSettings.top_margin + pageSettings.bottom_margin);
    const pageWidth = paperWidth - (pageSettings.right_margin + pageSettings.left_margin);
    var heightRatio = pageHeight / graphHeight;
    var widthRatio = pageWidth / graphWidth;

    var ratio = Math.min(heightRatio, widthRatio);
    var finalHeight = graphHeight * ratio;
    var finalWidth = graphWidth * ratio;
    return { height: finalHeight, width: finalWidth };
  };

  useEffect(() => {
    if (pageSettings.callForDownload) {
      const input = document.getElementById('areaToDownload') as HTMLElement;
      const d = new Date();
      const id = `${tabTileProps.selectedTabName}_${d.getDate()}${
        d.getMonth() + 1
      }${d.getFullYear()}:${d.getHours()}${d.getMinutes()}${d.getSeconds()}`;

      const returnToEditMode = () => {
        setTimeout(() => {
          dispatch(toggleDashMode('Edit'));
          dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'Edit'));
        }, 100); // 100ms delay
      };
      // options to fix Firefox download issues
      const toPngOptions = {
        cacheBust: false, // DISABLE this to prevent Firefox CORS errors
        fontEmbedCSS: '', // FIX: Disables the font parser that crashes Firefox
      };

      setTimeout(() => {
        if (pageSettings.downloadType === 'pdf') {
          // --- PDF DOWNLOAD ---
          toPng(input, toPngOptions)
            .then((imageData) => {
              const pdf = new jsPDF(
                pageSettings.SelectedOrientation,
                'px',
                pageSettings.selectedFormat,
              );
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = pdf.internal.pageSize.getHeight();

              const heightAndWidth = getHeightAndWidth(pdfHeight, pdfWidth);
              pdf.addImage(
                imageData,
                'PNG',
                pageSettings.left_margin,
                pageSettings.top_margin,
                heightAndWidth.width,
                heightAndWidth.height,
              );
              pdf.save(`${id}.pdf`);

              resetPageSettings();
              returnToEditMode();
            })
            .catch((err) => {
              console.error('PDF generation via toPng failed:', err);
              resetPageSettings();
              returnToEditMode();
            });
        } else {
          // --- IMAGE DOWNLOAD ---
          toPng(input, {
            ...toPngOptions,
            width: dimensions.width,
            height: dimensions.height,
          })
            .then((dataUrl: any) => {
              const link = document.createElement('a');
              link.download = `${id}.png`;
              link.href = dataUrl;

              // FIREFOX FIX: Must append to body, click, then remove
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              resetPageSettings();
              returnToEditMode();
            })
            .catch((err: any) => {
              Logger('error', 'Image download failed', err);
              resetPageSettings();
              returnToEditMode();
            });
        }
      }, 700);
    }
  }, [pageSettings.callForDownload]);
  // Every time the dimensions or dashboard layout changes,
  // recompute the space available for graph
  useEffect(() => {
    graphArea();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dimensions, tabState.tabs[tabTileProps.selectedTabId].dashLayout, tabTileProps.dashMode]);

  // Auto-scroll when new elements are added
  useEffect(() => {
    // If tab changed, updating refs without scrolling
    if (selectedTab !== prevTab.current) {
      prevTab.current = selectedTab;
      const currentTab = tabState.tabs[selectedTab];
      prevTilesLen.current = currentTab?.tilesInDashboard?.length || 0;
      prevImagesLen.current = currentTab?.dashboardObjects?.imageElements?.length || 0;
      prevTextLen.current = currentTab?.dashboardObjects?.richTextElements?.length || 0;
      return;
    }

    const currentTab = tabState.tabs[selectedTab];
    if (!currentTab) return;

    const tilesInDashboard = currentTab.tilesInDashboard || [];
    const imageElements = currentTab.dashboardObjects?.imageElements || [];
    const richTextElements = currentTab.dashboardObjects?.richTextElements || [];

    let targetY = -1;
    let addedCount = 0;

    // Checking for new Tile
    if (tilesInDashboard.length > prevTilesLen.current) {
      addedCount += tilesInDashboard.length - prevTilesLen.current;
      const newKey = tilesInDashboard[tilesInDashboard.length - 1];
      const details = currentTab.dashTilesDetails?.[newKey];
      if (details) targetY = details.y;
    }

    // Checking for new Image/Button
    if (imageElements.length > prevImagesLen.current) {
      addedCount += imageElements.length - prevImagesLen.current;
      const newEl = imageElements[imageElements.length - 1];
      if (newEl) targetY = newEl.y;
    }

    // Checking for new Rich Text
    if (richTextElements.length > prevTextLen.current) {
      addedCount += richTextElements.length - prevTextLen.current;
      const newEl = richTextElements[richTextElements.length - 1];
      if (newEl) targetY = newEl.y;
    }

    // Scroll if we found a target and exactly one element is added (prevents scrolling on playbook load)
    if (targetY >= 0 && addedCount === 1) {
      setTimeout(() => {
        if (targetRef.current) {
          const dashboardArea = targetRef.current.querySelector('.dashboardArea') as HTMLElement;
          const totalRows = dashboardRows || 1;

          if (dashboardArea && totalRows > 0) {
            const rowHeight = dashboardArea.clientHeight / totalRows;
            const containerHeight = targetRef.current.clientHeight;
            // Scrolling so the element is looks centered
            const scrollTop = Math.max(0, targetY * rowHeight - containerHeight / 3);

            targetRef.current.scrollTo({
              top: scrollTop,
              behavior: 'smooth',
            });
          }
        }
      }, 100);
    }

    // Reset custom layout if no interactive elements are present
    if (
      tilesInDashboard.length === 0 &&
      imageElements.length === 0 &&
      richTextElements.length === 0 &&
      currentTab.dashboardState.isCustomLayout
    ) {
      resetCustomLayout(selectedTab);
    }

    // Update refs
    prevTilesLen.current = tilesInDashboard.length;
    prevImagesLen.current = imageElements.length;
    prevTextLen.current = richTextElements.length;
  }, [
    tabState.tabs[selectedTab]?.tilesInDashboard?.length,
    tabState.tabs[selectedTab]?.dashboardObjects?.imageElements?.length,
    tabState.tabs[selectedTab]?.dashboardObjects?.richTextElements?.length,
    selectedTab,
    dashboardRows,
    tabState.tabs,
    dispatch,
  ]);

  // When dashboard is changed from edit to present mode, enable or disable
  // the grid like background in dashboard area
  useEffect(() => {
    if (tabTileProps.dashMode === 'Present') {
      setdashStyle1({
        ...dashStyle1,
        background: presentbackground,
      });
    } else if (tabTileProps.dashMode === 'Edit') {
      const imageUrl = ['dark', 'halloween', 'purplePassion', 'chalk'].includes(schemeColor)
        ? darkbackground
        : dashbackground;

      setdashStyle({
        ...dashStyle,
        background: `${backgroundColor} url(${imageUrl}) no-repeat center center / cover`,
      });
    }
  }, [tabTileProps.dashMode, schemeColor, backgroundColor]);

  let movement_timer: null | any = null;
  const RESET_TIMEOUT: number = 300;
  const handleResize = () => {
    clearInterval(movement_timer);
    movement_timer = setTimeout(test_dimensions, 10);
  };

  const test_dimensions = () => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.clientWidth,
        height: targetRef.current.clientHeight,
      });
    }
  };

  useLayoutEffect(() => {
    test_dimensions();
  }, [
    tabTileProps.showDash,
    tabTileProps.dashMode,
    showListofTileMenu,
    dashboardResizeColumn,
    showDashBoardFilterMenu,
    showObjectsSidebar,
    resolutionType,
  ]);

  // Given the dimension of dashboard area available,
  // if Fullscreen option or Aspect ratio option selected,
  // compute the width and height of available area for graphs
  useEffect(() => {
    if (softUI) {
      setdashStyle((prevStyle: any) => ({
        ...prevStyle,
        backgroundColor: backgroundColor,
        boxShadow: softUI ? '0 0 15px rgba(0,0,0,0.12)' : 'none', // Conditionally apply SoftUI box-shadow
        ...skeuomorphicStyle,
      }));
      setStyle((prevStyle: any) => ({
        ...prevStyle,
        backgroundColor: backgroundColor,
        ...tileskeuomorphicStyle,
      }));
      setStyle2((prevStyle: any) => ({
        ...prevStyle,
        backgroundColor: backgroundColor,
        ...skeuomorphicInnerStyle,
      }));
    } else {
      setdashStyle((prevStyle: any) => ({
        ...prevStyle,
        boxShadow: 'none',
        backgroundColor: backgroundColor,
        borderRadius: '0px',
      }));
      setStyle((prevStyle: any) => ({
        ...prevStyle,
        boxShadow: 'none',
        backgroundColor: backgroundColor,
        borderRadius: '0px',
      }));
      setStyle2((prevStyle: any) => ({
        ...prevStyle,
        boxShadow: 'none',
        backgroundColor: backgroundColor,
        borderRadius: '0px',
      }));
    }
  }, [backgroundColor, softUI]);

  // Ensure schemeColor and softUI are dependencies to trigger when they change
  const graphArea = () => {
    const dashLayoutProperty = tabState.tabs[tabTileProps.selectedTabId].dashLayout;

    if (resolutionType === 'autoWidth') {
      const gridCols = 65;
      const gridRows = 32;

      // Grid cell width is based on the container width
      const effectiveWidth =
        tabTileProps.dashMode === 'Present' ? Math.max(dimensions.width, 800) : dimensions.width;
      const columnWidth = effectiveWidth / gridCols;

      const rowHeight = getAutoWidthRowHeight();

      if (rowHeight <= 0) return;

      const finalWidth = columnWidth * (gridCols - 1);

      // Ensure finalHeight matches container height for autoWidth, or calculate based on rows
      // If we are just filling the screen (32 rows), use dimensions.height to avoid rounding gaps.
      // But if dashboardRows > 32, we calculate.
      const targetRows = dashboardRows || 32;
      const finalHeight = targetRows * rowHeight;

      const halfRows = Math.ceil(targetRows / 2);
      const largeGridHeight = halfRows * rowHeight;
      const largeGridWidth = finalWidth / 2;

      const newBackgroundSize = `${columnWidth}px ${rowHeight}px,
                             ${columnWidth}px ${rowHeight}px,
                             ${largeGridWidth}px ${largeGridWidth}px,
                             ${largeGridHeight}px ${largeGridHeight}px`;

      setinnerDimensions({ width: finalWidth, height: finalHeight });

      if (tabTileProps.dashMode === 'Present') {
        setdashStyle1((prev: any) => ({
          ...prev,
          width: finalWidth,
          height: finalHeight,
          backgroundColor: backgroundColor,
          backgroundSize: newBackgroundSize,
        }));
      } else if (tabTileProps.dashMode === 'Edit') {
        setdashStyle((prev: any) => ({
          ...prev,
          width: finalWidth,
          height: finalHeight,
          backgroundColor: backgroundColor,
          backgroundSize: newBackgroundSize,
        }));
      }

      setGridSize({ x: columnWidth, y: rowHeight });
      return;
    }

    // Handle Auto Scaling case
    if (resolutionType === 'fixedSize') {
      let effectiveWidth =
        tabTileProps.dashMode === 'Present' ? Math.max(dimensions.width, 800) : dimensions.width;

      let width = parseInt(autoScalingWidth) || effectiveWidth;
      let height = parseInt(autoScalingHeight) || dimensions.height;

      // 32 cols × 18 rows
      const gridCols = 64;
      const gridRows = 32;

      const gridX = Math.floor(width / gridCols);
      const gridY = Math.floor(height / gridRows);

      const gridSize = Math.min(gridX, gridY); // keep cells square

      const finalWidth = gridSize * gridCols;
      const finalHeight = gridSize * gridRows;

      setinnerDimensions({ width: finalWidth, height: finalHeight });

      if (tabTileProps.dashMode === 'Present') {
        setdashStyle1((prev: any) => ({
          ...prev,
          backgroundColor: backgroundColor,
          width: finalWidth,
          height: finalHeight,
          backgroundSize: `${gridSize}px ${gridSize}px, ${gridSize}px ${gridSize}px, ${finalWidth / 2}px ${finalWidth / 2}px, ${finalHeight / 2}px ${finalHeight / 2}px`,
        }));
      } else if (tabTileProps.dashMode === 'Edit') {
        setdashStyle((prev: any) => ({
          ...prev,
          backgroundColor: backgroundColor,
          width: finalWidth,
          height: finalHeight,
          backgroundSize: `${gridSize}px ${gridSize}px, ${gridSize}px ${gridSize}px, ${finalWidth / 2}px ${finalWidth / 2}px, ${finalHeight / 2}px ${finalHeight / 2}px`,
        }));
      }

      setGridSize({ x: gridSize, y: gridSize });
      return;
    }

    // ========================
    // Existing "Full Screen" logic (updated)
    if (resolutionType === 'autoFit') {
      const gridCols = 65;
      const gridRows = 32;
      const effectiveWidth =
        tabTileProps.dashMode === 'Present' ? Math.max(dimensions.width, 800) : dimensions.width;

      const gridWidth = effectiveWidth / gridCols;
      const gridHeight = Math.floor(dimensions.height / gridRows);

      // The key fix: set width and height to be an exact multiple of the grid size
      const fullWidth = gridWidth * (gridCols - 1);
      const fullHeight = gridHeight * gridRows;

      setinnerDimensions({ width: fullWidth, height: fullHeight });

      if (tabTileProps.dashMode === 'Present') {
        setdashStyle1((prev: any) => ({
          ...prev,
          backgroundColor: backgroundColor,
          width: fullWidth,
          height: fullHeight,
          backgroundSize: `${gridWidth}px ${gridHeight}px, ${gridWidth}px ${gridHeight}px, ${fullWidth / 2}px ${fullWidth / 2}px, ${fullHeight / 2}px ${fullHeight / 2}px`,
        }));
      } else if (tabTileProps.dashMode === 'Edit') {
        setdashStyle((prev: any) => ({
          ...prev,
          backgroundColor: backgroundColor,
          width: fullWidth,
          height: fullHeight,
          backgroundSize: `${gridWidth}px ${gridHeight}px, ${gridWidth}px ${gridHeight}px, ${fullWidth / 2}px ${fullWidth / 2}px, ${fullHeight / 2}px ${fullHeight / 2}px`,
        }));
      }

      setGridSize({ x: gridWidth, y: gridHeight });
      return;
    }

    // ========================
    // Existing "Aspect Ratio" logic (updated)
    if (
      dashLayoutProperty.dashboardLayout === 'Auto' &&
      dashLayoutProperty.selectedOptionForAuto === 'Aspect Ratio'
    ) {
      const aspectRatioWidth = dashLayoutProperty.aspectRatio.width * 2;
      const aspectRatioHeight = dashLayoutProperty.aspectRatio.height * 2;
      const effectiveWidth =
        tabTileProps.dashMode === 'Present' ? Math.max(dimensions.width, 800) : dimensions.width;

      const xUnit = Math.floor(effectiveWidth / aspectRatioWidth);
      const yUnit = Math.floor(dimensions.height / aspectRatioHeight);

      if (xUnit * aspectRatioHeight <= dimensions.height) {
        const truncatedX = xUnit;
        const finalWidth = truncatedX * aspectRatioWidth;
        const finalHeight = truncatedX * aspectRatioHeight;

        setinnerDimensions({ width: finalWidth, height: finalHeight });
        setdashStyle({
          ...dashStyle,
          width: finalWidth,
          height: finalHeight,
          backgroundSize: `${truncatedX}px ${truncatedX}px,
          ${truncatedX}px ${truncatedX}px,
          ${truncatedX * dashLayoutProperty.aspectRatio.width}px
          ${truncatedX * dashLayoutProperty.aspectRatio.width}px,
          ${truncatedX * dashLayoutProperty.aspectRatio.height}px
          ${truncatedX * dashLayoutProperty.aspectRatio.height}px`,
        });
        setGridSize({ x: truncatedX, y: truncatedX });
      }

      if (yUnit * aspectRatioWidth <= effectiveWidth) {
        const truncatedY = yUnit;
        const finalWidth = truncatedY * aspectRatioWidth;
        const finalHeight = truncatedY * aspectRatioHeight;

        setinnerDimensions({ width: finalWidth, height: finalHeight });
        setdashStyle({
          ...dashStyle,
          width: finalWidth,
          height: finalHeight,
          backgroundSize: `${truncatedY}px ${truncatedY}px,
          ${truncatedY}px ${truncatedY}px,
          ${truncatedY * dashLayoutProperty.aspectRatio.width}px
          ${truncatedY * dashLayoutProperty.aspectRatio.width}px,
          ${truncatedY * dashLayoutProperty.aspectRatio.height}px
          ${truncatedY * dashLayoutProperty.aspectRatio.height}px`,
        });
        setGridSize({ x: truncatedY, y: truncatedY });
      }
    }
  };

  // List of tiles to be mapped on the side of dashboard,
  // allowing users to choose graphs from these tiles
  let tilesForSelectedTab = tileState.tileList[tabTileProps.selectedTabId];
  const GAP = 1;
  const EDGE_GAP = 1;
  const GRID_WIDTH = 64;
  const COLUMN_WIDTH = 21;
  const HALF_WIDTH = 32;

  const tileList = tilesForSelectedTab.map((tile: any, index: number) => {
    const tileDetails = tileState.tiles[tile];
    const propKey: string = `${tileDetails.tabId}.${tileDetails.tileId}`;

    const currentTabDetails = tabState.tabs[tileDetails.tabId];
    const tilesInDash = currentTabDetails.tilesInDashboard;

    const isChecked = tilesInDash.includes(propKey);
    const propIndex = tilesInDash.indexOf(propKey);

    const targetIndex = isChecked ? propIndex : tilesInDash.length;

    const isCustomLayout = currentTabDetails.dashboardState?.isCustomLayout || false;

    // Determining tile dimensions based on index (sequential layout)
    const getDimensions = (idx: number) => {
      if (isCustomLayout) return { w: 31, h: 15 };
      if (idx < 4) return { w: 31, h: 15 };
      if (idx === 4) return { w: 31, h: 15 }; // 5th tile: half-width in row 2
      if (idx === 5) return { w: 21, h: 15 }; // 6th tile: one-third in row 2
      return { w: 21, h: 10 };
    };

    const { w, h } = getDimensions(targetIndex);

    // Function to find smart position for the tile (sequential: L-to-R, top-to-bottom)
    const getSmartPosition = (targetW: number, targetH: number) => {
      if (!isCustomLayout) {
        if ((resolutionType === 'autoFit' || resolutionType === 'fixedSize') && targetIndex >= 9) {
          const cycleIndex = targetIndex % 9;
          const col = cycleIndex % 3;
          const row = Math.floor(cycleIndex / 3);
          return { x: col * 21 + EDGE_GAP, y: row * 10 + EDGE_GAP };
        }
        // Sequential predefined positions for first 9 tiles
        // Tiles 0-3: 2x2 grid (handled by grid scan with w:31)
        // Tile 4 (5th): row 2 right-half (tile 3 moved to row 2 left-half via reflow)
        if (targetIndex === 4) return { x: 31 + EDGE_GAP, y: 15 + EDGE_GAP };
        // Tile 5 (6th): row 2 third-column (row 2 squeezed to thirds via reflow)
        if (targetIndex === 5) return { x: 42 + EDGE_GAP, y: 15 + EDGE_GAP };
        // Tiles 6-8: row 3, three across
        if (targetIndex === 6) return { x: EDGE_GAP, y: 20 + EDGE_GAP };
        if (targetIndex === 7) return { x: 21 + EDGE_GAP, y: 20 + EDGE_GAP };
        if (targetIndex === 8) return { x: 42 + EDGE_GAP, y: 20 + EDGE_GAP };
      }

      //For others, perform a grid scan to find the first available gap
      const existingDashTiles = tilesInDash
        .map((key: string) => currentTabDetails.dashTilesDetails[key])
        .filter(Boolean)
        .filter((t: any) => t.propKey !== propKey);

      const existingImagesAndButtons = currentTabDetails.dashboardObjects?.imageElements || [];
      const existingRichTexts = currentTabDetails.dashboardObjects?.richTextElements || [];

      const existingElements = [
        ...existingDashTiles,
        ...existingImagesAndButtons,
        ...existingRichTexts,
      ];

      // Function to check if a given rectangle overlaps with existing elements
      const isOccupied = (checkX: number, checkY: number, checkW: number, checkH: number) => {
        return existingElements.some((t: any) => {
          if (
            t.x === undefined ||
            t.y === undefined ||
            t.width === undefined ||
            t.height === undefined
          )
            return false;
          const horizontalOverlap = checkX < t.x + t.width + GAP && checkX + checkW > t.x;
          const verticalOverlap = checkY < t.y + t.height + GAP && checkY + checkH > t.y;
          return horizontalOverlap && verticalOverlap;
        });
      };

      const stepX = 1; // every X unit (or use 21/32 if you prefer rigid columns)
      const stepY = 1; // every 1 Y unit for precise gap placement

      // Define boundaries
      const DASH_MAX_HEIGHT = 32; // The visible height in AutoFit
      // In autoWidth (scrollable), we allow infinite height. In autoFit, we clamp it.
      const searchLimitY = resolutionType === 'autoWidth' ? 100 : DASH_MAX_HEIGHT;

      const maxCols = GRID_WIDTH;

      // 5. Scan for the first available "Hole" from Top-Left
      for (let y = EDGE_GAP; y < searchLimitY; y += stepY) {
        // Boundary check for Height
        if (resolutionType !== 'autoWidth' && y + targetH > DASH_MAX_HEIGHT) break;
        for (let x = EDGE_GAP; x < maxCols; x += stepX) {
          // Boundary check for Width
          if (x + targetW > GRID_WIDTH) continue;
          if (!isOccupied(x, y, targetW, targetH)) {
            // Found a valid gap!
            return { x, y };
          }
        }
      }

      // Fallback
      // If we are here, no gap was found in the visible area.

      if (resolutionType === 'autoWidth') {
        // In scrollable mode we can go out of bounds vertically
        let maxY = 0;
        existingElements.forEach((t: any) => {
          if (t.y !== undefined && t.height !== undefined) {
            const bottom = t.y + t.height;
            if (bottom > maxY) maxY = bottom;
          }
        });
        // in autoWidth,we can place it just below the lowest tile
        return { x: EDGE_GAP, y: maxY + EDGE_GAP };
      } else {
        // In AutoFit/Fixed, we CANNOT go out of bounds.
        // Force placement at 0,0  in autoFit so donn't exceed visible area.
        // For now, fail-safe to 0,0 to ensure user sees it.
        return { x: EDGE_GAP, y: EDGE_GAP };
      }
    };

    const position = getSmartPosition(w, h);

    const finalWidth = w - GAP;
    const finalHeight = h - GAP;

    const dashSpecs = {
      name: tileDetails.tileName,
      highlight: false,
      propKey,
      tileId: tileDetails.tileId,
      width: finalWidth,
      height: finalHeight,
      x: position.x,
      y: position.y,
    };

    const isClickedHighlight =
      tabState.tabs[tabTileProps.selectedTabId].dashTilesDetails[propKey]?.highlight;
    const isHovered = hoveredTileKey === propKey;
    const isSelected = selectedTileKey === propKey;

    //function to handle layout reflow on adding tiles (sequential: L-to-R, top-to-bottom)
    const handleLayoutReflow = (isAdding: boolean) => {
      if (!isAdding) return;

      const isCustomLayout = currentTabDetails.dashboardState?.isCustomLayout || false;
      const selectedTabId = tabTileProps.selectedTabId;

      if (!isCustomLayout) {
        const oneThirdWidth = COLUMN_WIDTH - GAP;
        const compactHeight = 10 - GAP;

        const updateTile = (
          key: string,
          newX: number,
          newY: number,
          newW: number,
          newH: number,
        ) => {
          dispatch(updateDashGraphSize(selectedTabId, key, newX, newY, newW, newH, true));
        };

        // When adding the 5th tile (tilesInDash currently has 4):
        // Reflow: Row 1 = tiles[0,1,2] one-third  |  Row 2 = tiles[3] half-width, (new tile at right-half)
        if (tilesInDash.length === 4) {
          const halfWidth = 31 - GAP; // half-width for row 2 (matches finalWidth of w:31 tiles)
          const sequentialPositions = [
            { x: EDGE_GAP, y: EDGE_GAP, w: oneThirdWidth }, // tile 0 → row 1, col 1
            { x: 21 + EDGE_GAP, y: EDGE_GAP, w: oneThirdWidth }, // tile 1 → row 1, col 2
            { x: 42 + EDGE_GAP, y: EDGE_GAP, w: oneThirdWidth }, // tile 2 → row 1, col 3
            { x: EDGE_GAP, y: 15 + EDGE_GAP, w: halfWidth }, // tile 3 → row 2, left-half
          ];
          tilesInDash.forEach((existingKey: string, i: number) => {
            if (i < sequentialPositions.length) {
              const pos = sequentialPositions[i];
              const details = tabState.tabs[selectedTabId].dashTilesDetails[existingKey];
              if (details) {
                updateTile(existingKey, pos.x, pos.y, pos.w, details.height);
              }
            }
          });
        }
        // When adding the 6th tile (tilesInDash currently has 5):
        // Row 2 tiles (tiles[3], tiles[4]) squeeze from half to one-third width
        else if (tilesInDash.length === 5) {
          const sequentialPositions = [
            { x: EDGE_GAP, y: EDGE_GAP, w: oneThirdWidth }, // tile 0 → row 1, col 1
            { x: 21 + EDGE_GAP, y: EDGE_GAP, w: oneThirdWidth }, // tile 1 → row 1, col 2
            { x: 42 + EDGE_GAP, y: EDGE_GAP, w: oneThirdWidth }, // tile 2 → row 1, col 3
            { x: EDGE_GAP, y: 15 + EDGE_GAP, w: oneThirdWidth }, // tile 3 → row 2, col 1
            { x: 21 + EDGE_GAP, y: 15 + EDGE_GAP, w: oneThirdWidth }, // tile 4 → row 2, col 2
          ];
          tilesInDash.forEach((existingKey: string, i: number) => {
            if (i < sequentialPositions.length) {
              const pos = sequentialPositions[i];
              const details = tabState.tabs[selectedTabId].dashTilesDetails[existingKey];
              if (details) {
                updateTile(existingKey, pos.x, pos.y, pos.w, details.height);
              }
            }
          });
        }
        // When adding the 7th tile (tilesInDash currently has 6):
        // All tiles compact to 3 rows of 3 columns
        else if (tilesInDash.length === 6) {
          tilesInDash.forEach((existingKey: string, i: number) => {
            const col = i % 3;
            const row = Math.floor(i / 3);
            const newX = col * COLUMN_WIDTH + EDGE_GAP;
            const newY = row * 10 + EDGE_GAP;
            updateTile(existingKey, newX, newY, oneThirdWidth, compactHeight);
          });
        }
      }

      if (resolutionType === 'autoWidth') {
        const bottomGridY = position.y + h;
        if (bottomGridY > dashboardRows) {
          // Checking against current rows
          dispatch(setDashboardRows(selectedTabId, bottomGridY));
        }
      }
    };

    const containerClass = isClickedHighlight
      ? 'listOfGraphsHighlighted'
      : `listOfGraphs ${isHovered ? 'listOfGraphsHover' : ''} ${isSelected ? 'listOfGraphsSelected' : ''}`;

    const truncatedName =
      tileDetails.tileName.length > 25
        ? tileDetails.tileName.substring(0, 25).trim() + '...'
        : tileDetails.tileName;

    return (
      <div
        style={{
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: '8px',
        }}
        key={propKey}
        className={containerClass}
        onClick={() => {
          dispatch(setSelectedTile(propKey));
        }}
        onMouseEnter={() => dispatch(setHoveredTile(propKey))}
        onMouseLeave={() => dispatch(clearHoveredTile())}
      >
        <div style={{ display: 'flex', flex: 1, minWidth: 0, alignItems: 'center' }}>
          <Checkbox
            sx={{
              '&.Mui-checked': { color: '#6f6f6fff' },
              '&.Mui-disabled': { color: '#B1B1B1' },
            }}
            style={{ width: '0.5rem', height: '0.5rem', margin: 'auto 5px auto 0' }}
            size="small"
            checked={isChecked}
            onClick={(e) => e.stopPropagation()}
            onChange={(event) => {
              const isAdding = event.target.checked;
              handleLayoutReflow(isAdding);
              updateDashBoardFilters(event, propKey);
              updateDashDetails(
                isChecked,
                propKey,
                dashSpecs,
                tabTileProps.selectedTabId,
                propIndex,
              );
              dispatch(callQueryAPIDashboard(true));
            }}
          />
          <Tooltip
            title={tileDetails.tileName}
            placement="top"
            slotProps={{ tooltip: { sx: { fontSize: '12px' } } }}
          >
            <span
              className="graphName"
              style={{
                color: iconColor,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',

                display: 'block',
              }}
            >
              {truncatedName}
            </span>
          </Tooltip>
        </div>

        {isHovered && (
          <Tooltip
            title="Go to this tile"
            placement="left"
            slotProps={{ tooltip: { sx: { fontSize: '12px' } } }}
          >
            <LaunchIcon
              sx={{
                fontSize: '16px',
                color: iconColor,
                cursor: 'pointer',
                opacity: 0.7,
                '&:hover': { opacity: 1 },
              }}
              onClick={(e) => {
                e.stopPropagation();
                selectTile(
                  tileDetails.tabId,
                  tileDetails.tileName,
                  tileDetails.tileId,
                  currentTabDetails.nextTileId,
                  false,
                );
              }}
            />
          </Tooltip>
        )}
      </div>
    );
  });
  const activeTilesInDashboard = tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard;
  const hasCheckedTiles = tilesForSelectedTab.some((tile: any) => {
    const currentObj = tileState.tiles[tile];
    const propKey = `${currentObj.tabId}.${currentObj.tileId}`;
    return activeTilesInDashboard.includes(propKey);
  });

  const handleClearAllTiles = () => {
    const currentTabId = tabTileProps.selectedTabId;
    const checkedTiles = [...activeTilesInDashboard];
    checkedTiles.forEach((propKey: string) => {
      const tileId = propKey.split('.')[1];
      const currentObj = tileState.tiles[tileId];
      const dashSpecs = {
        name: currentObj?.tileName || '',
        highlight: false,
        propKey,
        tileId: tileId,
        width: 0,
        height: 0,
        x: 0,
        y: 0,
      };

      updateDashDetails(true, propKey, dashSpecs, currentTabId, -1);
      updateDashBoardFilters({ target: { checked: false } }, propKey);
    });
    const currentTab = tabState.tabs[currentTabId];
    if (
      currentTab?.dashboardObjects?.imageElements?.length === 0 &&
      currentTab?.dashboardObjects?.richTextElements?.length === 0
    ) {
      resetCustomLayout(currentTabId);
    }
  };
  const finalTileList = (
    <>
      {tileList}
      {hasCheckedTiles && (
        <div
          style={{
            marginTop: '10px',
            padding: '8px 0',
            borderTop: `1px solid ${iconColor}20`,
            marginLeft: '.1rem',
          }}
        >
          <button
            onClick={handleClearAllTiles}
            style={{
              width: '97%',
              padding: '6px 12px',
              backgroundColor: 'transparent',
              color: iconColor,
              border: `1px solid ${iconColor}`,
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = `${iconColor}15`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            Clear All Tiles
          </button>
        </div>
      )}
    </>
  );

  const updateDashBoardFilters = (event: any, tileSelected: string) => {
    if (event.target.checked) {
      chartGroup?.tabTile[tileSelected]?.forEach((groupID: string) => {
        if (!dashBoardGroup?.filterGroupTabTiles[groupID]) {
          addDashBoardFilterGroupTabTiles(groupID);
        }

        if (!dashBoardGroup.groups.includes(groupID)) {
          updateDashBoardGroups(groupID);
        }

        let tabTilesList: any = [];
        tabTilesList.push(tileSelected);
        dispatch(updateDashBoardSelectedTabTiles(groupID, tileSelected));
        // setDashBoardFilterGroupsTabTiles(groupID, tabTilesList);
      });
    } else {
      dashBoardGroup.groups?.forEach((groupID: string) => {
        if (dashBoardGroup.filterGroupTabTiles[groupID].includes(tileSelected)) {
          if (dashBoardGroup.filterGroupTabTiles[groupID].length === 1) {
            deleteDashBoardSelectedGroup(groupID);
            deleteDashBoardSelectedGroupAllTabTiles(groupID);
          } else {
            deleteDashBoardSelectedTabTiles(
              groupID,
              dashBoardGroup.filterGroupTabTiles[groupID].findIndex(
                (id: string) => id === tileSelected,
              ),
            );
          }
        }
      });
    }
  };

  // calculate the grid unit size based on the resolution type
  const calculateGridUnitSize = () => {
    if (resolutionType === 'autoWidth') {
      const gridCols = 64;
      return Math.floor(dimensions.width / gridCols);
    } else if (resolutionType === 'fixedSize') {
      const gridCols = 64;
      const gridRows = 32;
      const gridX = Math.floor(dimensions.width / gridCols);
      const gridY = Math.floor(dimensions.height / gridRows);
      return Math.min(gridX, gridY);
    } else if (resolutionType === 'autoFit') {
      const gridX = Math.floor(dimensions.width / 64);
      const gridY = Math.floor(dimensions.height / 32);
      return Math.min(gridX, gridY);
    }

    return 20; // default fallback
  };
  const AUTO_WIDTH_ROWS = 32;

  const getAutoWidthRowHeight = () => {
    if (!dimensions.height) return 0;
    return Math.floor(dimensions.height / AUTO_WIDTH_ROWS);
  };

  // Function to adjust width and height to nearest grid unit
  const getAdjustedDimensions = (width: number, height: number) => {
    const gridUnit = calculateGridUnitSize();

    // Round both width and height to nearest multiple of grid unit
    const adjustedWidth = Math.floor(width / gridUnit) * gridUnit;
    const adjustedHeight = Math.floor(height / gridUnit) * gridUnit;

    return { width: adjustedWidth, height: adjustedHeight };
  };

  const MAX_DASHBOARD_ROWS = 128; // maximum rows allowed
  const isAtMaxRows = dashboardRows >= MAX_DASHBOARD_ROWS;
  const isAtMinRows = dashboardRows <= 32;

  const handleIncreaseHeight = () => {
    if (isAtMaxRows) return;
    const rowsToAdd = heightAdjustment;
    const newRows = Math.min(MAX_DASHBOARD_ROWS, dashboardRows + rowsToAdd);
    dispatch(setDashboardRows(selectedTab, newRows));
    setTimeout(() => {
      if (targetRef.current) {
        targetRef.current.scrollTop = targetRef.current.scrollHeight;
      }
    }, 50);
  };

  const handleDecreaseHeight = () => {
    const rowsToSubtract = heightAdjustment;
    const newRows = Math.max(32, dashboardRows - rowsToSubtract); // Minimum 32 rows
    dispatch(setDashboardRows(selectedTab, newRows));
    const gridUnitY = getAutoWidthRowHeight();
    const newHeight = gridUnitY * newRows;
    clampElementsInsideDashboard(newHeight);
  };
  // Function to clamp elements inside the dashboard area
  // This ensures that elements do not overflow the dashboard height
  const clampElementsInsideDashboard = useCallback(
    (newDashboardHeight: number) => {
      const currentTab = tabState.tabs[selectedTab];
      if (!currentTab) return;

      const graphKeys = currentTab.tilesInDashboard || [];
      const imageElements = currentTab.dashboardObjects.imageElements || [];

      const gridY = Number(tabTileProps.dashGridSize?.y) || 32;
      const maxRows = Math.floor(newDashboardHeight / gridY);
      const ROW_GAP = 1;
      const clampLimit = maxRows - ROW_GAP;

      for (let i = 0; i < graphKeys.length; i++) {
        const graphKey = graphKeys[i];
        const graph = currentTab.dashTilesDetails[graphKey];

        const graphBottom = graph.y + graph.height;
        if (graphBottom > clampLimit) {
          const newY = Math.max(0, clampLimit - graph.height);

          dispatch(
            updateDashGraphSize(
              selectedTab,
              graphKey,
              graph.x,
              newY,
              graph.width,
              graph.height,
              true,
            ),
          );
        }
      }

      for (let i = 0; i < imageElements.length; i++) {
        const img = imageElements[i];
        const imgBottom = img.y + img.height;
        if (imgBottom > clampLimit) {
          const newY = Math.max(0, clampLimit - img.height);
          dispatch(updateImageSize(selectedTab, img.id, img.width, img.height, img.x, newY, true));
        }
      }

      const richTextElements = currentTab.dashboardObjects.richTextElements || [];
      for (let i = 0; i < richTextElements.length; i++) {
        const rt = richTextElements[i];
        const rtBottom = rt.y + rt.height;
        if (rtBottom > clampLimit) {
          const newY = Math.max(0, clampLimit - rt.height);
          dispatch(updateRichTextElement(selectedTab, rt.id, { y: newY }));
        }
      }
    },
    [tabState, selectedTab, tabTileProps, dispatch],
  );
  const updateDashboardDimensions = (width: number, height: number) => {
    const { width: adjustedWidth, height: adjustedHeight } = getAdjustedDimensions(width, height);

    setDimensions({
      width: adjustedWidth,
      height: adjustedHeight,
    });
    dispatch(setDashboardHeight(selectedTab, adjustedHeight));

    clampElementsInsideDashboard(adjustedHeight);
  };

  // Function to handle auto-fitting the layout of the dashboard
  const handleAutoFitLayout = useCallback(
    (forceLayout = false) => {
      const currentTab = tabState.tabs[selectedTab];
      if (!currentTab) return;

      const graphs = currentTab.tilesInDashboard || [];
      const imageElements = currentTab.dashboardObjects.imageElements || [];
      const total = graphs.length + imageElements.length;
      if (total === 0) return;

      if (resolutionType !== 'autoFit' && resolutionType !== 'autoWidth' && !forceLayout) return;

      const dashboardWidth = dimensions.width;
      const dashboardHeight = dimensions.height;
      const gridX = Math.floor(dashboardWidth / 64);
      const gridY = Math.floor(dashboardHeight / 32);

      const outerPaddingGrids = 1; // 1 grid unit padding from Dashboard edges
      const gapGrids = 1; // exactly 1 grid unit gap

      const totalWidthGrids = Math.floor(dashboardWidth / gridX);
      const totalHeightGrids = Math.floor(dashboardHeight / gridY);

      // Decide grid cols/rows just for sizing
      let rows, cols;
      if (total === 1) {
        rows = 2;
        cols = 2;
      } else if (total === 2) {
        rows = 2;
        cols = 2;
      } else if (total <= 4) {
        rows = 2;
        cols = 2;
      } else if (total <= 6) {
        rows = 2;
        cols = 3;
      } else if (total <= 9) {
        rows = 3;
        cols = 3;
      } else {
        rows = 3;
        cols = 3;
      }

      const availableWidthGrids = totalWidthGrids - cols;
      const availableHeightGrids = totalHeightGrids - rows;
      const elementWidthGrids = Math.floor(availableWidthGrids / cols - 1);
      const elementHeightGrids = Math.floor(availableHeightGrids / rows);

      const getPosition = (idx: number) => {
        let xGrid, yGrid;

        if (total === 2) {
          // 2 items → top-left, top-right
          xGrid = outerPaddingGrids + idx * (elementWidthGrids + gapGrids);
          yGrid = outerPaddingGrids;
        } else if (total === 3) {
          // 3 items → top-left, top-right, bottom-left
          if (idx < 2) {
            xGrid = outerPaddingGrids + idx * (elementWidthGrids + gapGrids);
            yGrid = outerPaddingGrids;
          } else {
            xGrid = outerPaddingGrids;
            yGrid = outerPaddingGrids + elementHeightGrids + gapGrids;
          }
        } else if (total === 4) {
          const row = Math.floor(idx / 2);
          const col = idx % 2;
          xGrid = outerPaddingGrids + col * (elementWidthGrids + gapGrids);
          yGrid = outerPaddingGrids + row * (elementHeightGrids + gapGrids);
        } else if (total <= 6) {
          const row = Math.floor(idx / 3);
          const col = idx % 3;
          xGrid = outerPaddingGrids + col * (elementWidthGrids + gapGrids);
          yGrid = outerPaddingGrids + row * (elementHeightGrids + gapGrids);
        } else if (total <= 9) {
          const row = Math.floor(idx / 3);
          const col = idx % 3;
          xGrid = outerPaddingGrids + col * (elementWidthGrids + gapGrids);
          yGrid = outerPaddingGrids + row * (elementHeightGrids + gapGrids);
        } else {
          const col = idx % 3;
          const row = Math.floor(idx / 3);
          xGrid = outerPaddingGrids + col * (elementWidthGrids + gapGrids);
          yGrid = outerPaddingGrids + (row % 3) * (elementHeightGrids + gapGrids);
        }

        return { xGrid, yGrid };
      };

      let index = 0;

      // Position & resize graphs
      for (let i = 0; i < graphs.length; i++, index++) {
        const { xGrid, yGrid } = getPosition(index);
        dispatch(
          updateDashGraphSize(
            selectedTab,
            graphs[i],
            xGrid,
            yGrid,
            elementWidthGrids,
            elementHeightGrids,
            true,
          ),
        );
      }

      // Position & resize images
      for (let i = 0; i < imageElements.length; i++, index++) {
        const { xGrid, yGrid } = getPosition(index);
        if (imageElements[i].type === 'icon-button') {
          dispatch(
            updateImageSize(
              selectedTab,
              imageElements[i].id,
              imageElements[i].width,
              imageElements[i].height,
              xGrid,
              yGrid,
              true,
            ),
          );
        } else {
          dispatch(
            updateImageSize(
              selectedTab,
              imageElements[i].id,
              elementWidthGrids,
              elementHeightGrids,
              xGrid,
              yGrid,
              true,
            ),
          );
        }
      }
    },
    [tabState, selectedTab, resolutionType, dimensions, softUI, dispatch],
  );

  var themeOptions: any[] = [
    { type: 'SoftUI', title: 'Soft UI' },
    { type: 'FlatUI', title: 'Flat UI' },
  ];

  const softUISliderComponent = (
    <div
      id="theme-scheme-wrapper"
      style={{
        textAlign: 'center',
        marginLeft: '-0.2rem',
        paddingRight: '0.2rem',
        marginTop: '.5rem',
      }}
    >
      {/* Tab Navigation */}
      <div className="chartOptionImagesContainer">
        {[
          { key: 'theme', label: 'Theme' },
          { key: 'colorScheme', label: 'Color Scheme' },
          { key: 'resolution', label: 'Aspect Ratio' },
          { key: 'fontfamily', label: 'Font Family' },
          { key: 'filter', label: 'Filter Settings' },
          { key: 'interactivity', label: 'Interactivity' },
        ].map(({ key, label }) => {
          const isSelected = selectedOption === key;

          return (
            <div
              key={key}
              onClick={() => setSelectedOption(key)}
              className={`optionImage ${isSelected ? 'optionImageSelected' : ''}`}
              style={{
                color: iconColor,
                backgroundColor: isSelected ? selectedTabBackgroundColor : 'transparent',
                border: `2px solid ${
                  isSelected ? selectedTabBackgroundColor : 'rgba(224, 224, 224, 1)'
                }`,
                fontWeight: isSelected ? 600 : 400,
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
            >
              {label}
            </div>
          );
        })}
      </div>

      {/* Content based on selected tab */}
      <div className="optionsInfo">
        {selectedOption === 'theme' && (
          <div>
            <Box
              className="theme-options"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                paddingTop: '0.5rem',
                marginBottom: '0.7rem',
                justifyContent: 'center',
              }}
            >
              <div className="radioButtons" style={{ display: 'flex' }}>
                {themeOptions.map((option) => {
                  const isSelected = theme === option.type;
                  return (
                    <div
                      key={option.type}
                      className={isSelected ? 'radioButtonSelected' : 'radioButton'}
                      onClick={() => handleThemeChange(option.type)}
                      title={option.title}
                      style={{
                        backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
                        cursor: isSelected ? 'auto' : 'pointer',
                        fontWeight: isSelected ? '600' : 'normal',
                      }}
                    >
                      {option.title}
                    </div>
                  );
                })}
              </div>

              {!softUI ? (
                <div
                  style={{
                    textAlign: 'left',
                    color: '#333',
                    fontSize: '13px',
                    accentColor: '#2bb9bb',
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'flex-start',
                    transform: 'translateX(6px)',
                    marginLeft: '5px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',

                      width: '100%',
                    }}
                  >
                    <div
                      className="optionDescription"
                      style={{
                        color: iconColor,
                        fontSize: '13px',
                        marginLeft: '-11px',
                        marginTop: '-4px',
                      }}
                    >
                      Tile Border
                    </div>
                    <div style={{ transform: 'translateX(62px)' }}>
                      <SwitchWithInput isChecked={!!applyBorder} onSwitch={handleApplyBorder} />
                    </div>
                  </div>
                </div>
              ) : null}

              {!softUI && applyBorder ? (
                <BorderControles iconColor={iconColor} tabId={tabId} />
              ) : null}

              <Divider sx={{ my: 0.5, borderColor: 'lightgray', mx: 1 }} />
              <div
                style={{
                  textAlign: 'left',
                  color: '#333',
                  fontSize: '13px',
                  marginBottom: '15px',
                  accentColor: '#2bb9bb',
                  display: 'flex',
                  gap: '0.5rem',
                  alignItems: 'flex-start',
                  transform: 'translateX(-1px)',
                  marginLeft: '5px',
                }}
              >
                <input
                  type="checkbox"
                  id="applyTheme"
                  className="checkbox_tick"
                  checked={applyThemeAcrossPlaybook}
                  onChange={() => handleApplyThemeChange()}
                  style={{
                    verticalAlign: 'middle',
                    transform: 'scale(0.8)',
                    marginLeft: 0,
                    marginTop: '1px',
                  }}
                />
                <label htmlFor="applyTheme" style={{ color: iconColor }}>
                  Apply Theme across Playbook
                </label>
              </div>
            </Box>
          </div>
        )}

        {selectedOption === 'filter' && (
          <div style={{ marginTop: '-20px' }}>
            <div
              className="optionDescription"
              style={{
                fontSize: '13px',
                color: iconColor,
                marginBottom: '5px',
                textAlign: 'left',
                paddingLeft: '4px',
              }}
            >
              Filter Panel Visibility:
            </div>

            <div
              style={{
                display: 'flex',
                width: 'auto',
                padding: '0.2rem 0.5rem 0.2rem 0',
                cursor: 'pointer',
                alignItems: 'center',
              }}
              onClick={() => dispatch(setFilterVisibilityMode(selectedTab, 'present'))}
            >
              <span style={{ width: '2rem', paddingLeft: '5px' }}>
                <Radio
                  checked={filterVisibilityMode === 'present'}
                  size="small"
                  style={{ padding: 0, color: '#828383ff' }}
                />
              </span>
              <div style={{ flex: 1, fontSize: '13px', color: iconColor, textAlign: 'left' }}>
                Enable when items present
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                width: 'auto',
                padding: '0.2rem 0.5rem 0.2rem 0',
                cursor: 'pointer',
                alignItems: 'center',
              }}
              onClick={() => dispatch(setFilterVisibilityMode(selectedTab, 'always'))}
            >
              <span style={{ width: '2rem', paddingLeft: '5px' }}>
                <Radio
                  checked={filterVisibilityMode === 'always'}
                  size="small"
                  style={{ padding: 0, color: '#828383ff' }}
                />
              </span>
              <div style={{ flex: 1, fontSize: '13px', color: iconColor, textAlign: 'left' }}>
                Always Enable
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                width: 'auto',
                padding: '0.2rem 0.5rem 0.2rem 0',
                cursor: 'pointer',
                alignItems: 'center',
              }}
              onClick={() => dispatch(setFilterVisibilityMode(selectedTab, 'disable'))}
            >
              <span style={{ width: '2rem', paddingLeft: '5px' }}>
                <Radio
                  checked={filterVisibilityMode === 'disable'}
                  size="small"
                  style={{ padding: 0, color: '#828383ff' }}
                />
              </span>
              <div style={{ flex: 1, fontSize: '13px', color: iconColor, textAlign: 'left' }}>
                Always Disable
              </div>
            </div>

            {filterVisibilityMode !== 'disable' && (
              <>
                <div
                  className="optionDescription"
                  style={{
                    fontSize: '13px',
                    color: iconColor,
                    marginBottom: '5px',
                    marginTop: '15px',
                    textAlign: 'left',
                    paddingLeft: '4px',
                  }}
                >
                  Filter Panel Mode:
                </div>

                <div
                  style={{
                    display: 'flex',
                    width: 'auto',
                    padding: '0.2rem 0.5rem 0.2rem 0',
                    cursor: 'pointer',
                    alignItems: 'center',
                  }}
                  onClick={() => dispatch(setFilterPanelMode(selectedTab, 'expand'))}
                >
                  <span style={{ width: '2rem', paddingLeft: '5px' }}>
                    <Radio
                      checked={filterPanelMode === 'expand'}
                      size="small"
                      style={{ padding: 0, color: '#828383ff' }}
                    />
                  </span>
                  <div style={{ flex: 1, fontSize: '13px', color: iconColor, textAlign: 'left' }}>
                    Expand
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    width: 'auto',
                    padding: '0.2rem 0.5rem 0.2rem 0',
                    cursor: 'pointer',
                    alignItems: 'center',
                  }}
                  onClick={() => dispatch(setFilterPanelMode(selectedTab, 'collapse'))}
                >
                  <span style={{ width: '2rem', paddingLeft: '5px' }}>
                    <Radio
                      checked={filterPanelMode === 'collapse'}
                      size="small"
                      style={{ padding: 0, color: '#828383ff' }}
                    />
                  </span>
                  <div style={{ flex: 1, fontSize: '13px', color: iconColor, textAlign: 'left' }}>
                    Collapse
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {selectedOption === 'interactivity' && (
          <div style={{ marginTop: '0px' }}>
            <div
              style={{
                textAlign: 'left',
                color: '#333',
                fontSize: '13px',
                accentColor: '#2bb9bb',
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'flex-start',
                transform: 'translateX(6px)',
                marginLeft: '5px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',

                  width: '100%',
                }}
              >
                <div
                  className="optionDescription"
                  style={{
                    color: iconColor,
                    fontSize: '13px',
                    marginLeft: '-11px',
                    marginTop: '-4px',
                  }}
                >
                  Mouseover Interactivity
                </div>
                <div style={{ transform: 'translateX(62px)' }}>
                  <SwitchWithInput
                    isChecked={!!mouseOverInteractivity}
                    onSwitch={handleToggleMouseOverInteractivity}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {selectedOption === 'fontfamily' && (
          <div style={{ marginTop: '-20px' }}>
            <div
              className="optionDescription"
              style={{
                fontSize: '13px',
                color: iconColor,
                marginBottom: '5px',
                textAlign: 'left',
                paddingLeft: '4px',
              }}
            >
              Font Family:
            </div>
            <FormControl
              fullWidth
              size="small"
              style={{
                fontSize: '12px',
                borderRadius: '4px',
                paddingLeft: '4px',
                backgroundColor: tabAreaBackgroundColor,
              }}
            >
              <Select
                value={selectedFontFamily}
                variant="outlined"
                onChange={(e) => {
                  const newFontFamily = e.target.value;
                  dispatch(setFontFamily(tabId, newFontFamily));
                }}
                sx={{
                  fontSize: '12px',
                  width: '99%',
                  margin: '0 auto 0.5rem auto',
                  fontFamily: selectedFontFamily,
                  backgroundColor: tabAreaBackgroundColor,
                  height: '1.5rem',
                  color: iconColor,
                  textAlign: 'left',
                  '.MuiSelect-icon': { color: iconColor },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'lightgray',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'lightgray',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2bb9bb',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      ml: '.6rem',
                      '& .MuiMenuItem-root.Mui-selected': {
                        backgroundColor: 'rgba(43, 185, 187, 0.1) !important',
                      },
                      '& .MuiMenuItem-root.Mui-selected:hover': {
                        backgroundColor: 'rgba(43, 185, 187, 0.2) !important',
                      },
                    },
                  },
                }}
              >
                {FontFamilies.map((font: any) => (
                  <MenuItem
                    key={font.id}
                    value={font.cssValue}
                    sx={{
                      padding: '2px 10px',
                      fontSize: '12px',
                      fontFamily: font.cssValue,
                    }}
                  >
                    {font.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div
              style={{
                textAlign: 'left',
                color: '#333',
                fontSize: '13px',
                accentColor: '#2bb9bb',
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'flex-start',
                transform: 'translateX(-1px)',
                marginLeft: '6px',
                marginTop: '0.5rem',
              }}
            >
              <input
                type="checkbox"
                id="applyFontToAll"
                className="checkbox_tick"
                checked={fontFamilyForAllTiles || false}
                onChange={handleApplyFontToAllChange}
                style={{
                  verticalAlign: 'middle',
                  transform: 'scale(0.8)',
                  marginLeft: 0,
                  marginTop: '1px',
                }}
              />
              <label htmlFor="applyFontToAll" style={{ color: iconColor }}>
                Apply font style to all Tiles
              </label>
            </div>
          </div>
        )}
        {selectedOption === 'colorScheme' && (
          <div style={{ marginTop: '10px' }}>
            {(() => {
              const isAutoMode = !tilesTodashboard;
              const activeKey = isAutoMode ? 'auto' : 'manual';

              return (
                <>
                  <div>
                    <OrientationRadioGroup
                      orientation={activeKey}
                      options={[
                        { name: 'Auto', key: 'auto' },
                        { name: 'Manual', key: 'manual' },
                      ]}
                      onChange={(clickedKey) => {
                        if (clickedKey !== activeKey) handleToggleTilesTheme();
                      }}
                    />
                  </div>

                  {isAutoMode && (
                    <>
                      <div
                        className="colorSchemeSelector"
                        style={{ color: iconColor, marginTop: '-16px' }}
                      >
                        <ChartColors
                          from="dashboard"
                          color={iconColor}
                          selectedTab={selectedTab}
                          onBackgroundColorChange={(color: {
                            schemeName: string;
                            color: string;
                          }) => {
                            // Extract schemeName and color from the object
                            const { schemeName, color: backgroundColor } = color;
                            setSchemeColor(schemeName);
                            //setDashColorScheme(schemeName, selectedTab);
                            // Update state or perform other actions
                            setBackgroundColor(backgroundColor); // Example: Updating a state in the parent
                            //Setting Color scheme for all tiles in a particular tab
                            if (ApplytoAllTabs) {
                              // Apply to all tabs
                              const themeId_passed =
                                allThemes.find((theme) => theme.name === schemeName)?.themeId ||
                                schemeName;
                              Object.keys(tabState.tabs).forEach((tabkey) => {
                                setDashColorScheme(schemeName, parseInt(tabkey, 10));
                                tileState.tileList[parseInt(tabkey, 10)].forEach((propkey) => {
                                  dispatch(setColorScheme(propkey, schemeName));
                                  dispatch(setTileThemeId(propkey, themeId_passed));
                                });
                              });
                            }
                            if (!ApplytoAllTabs) {
                              const allTilesForSelectedTab = tileState.tileList[selectedTab];
                              setDashColorScheme(schemeName, selectedTab);

                              // Commenting below code to prevent resetting of color scheme to peacock
                              // allTilesForSelectedTab.forEach((propkey) =>
                              //   dispatch(setColorScheme(propkey, scheme_passed))
                              // );
                            }

                            if (ApplytoTiles) {
                              // Apply to all tiles, the color scheme
                              const themeId_passed =
                                allThemes.find((theme) => theme.name === schemeName)?.themeId ||
                                schemeName;
                              const allTilesForSelectedTab = tileState.tileList[selectedTab];
                              allTilesForSelectedTab.forEach((propkey) => {
                                dispatch(setColorScheme(propkey, scheme_passed));
                                dispatch(setTileThemeId(propkey, themeId_passed));
                              });
                            }
                          }}
                        />
                      </div>

                      <div style={{ paddingLeft: '0.5rem', marginTop: '10px' }}>
                        <div
                          className="optionDescription"
                          style={{
                            fontSize: '13px',
                            color: iconColor,
                            marginBottom: '5px',
                            marginTop: '10px',
                            textAlign: 'left',
                            paddingLeft: '2px',
                          }}
                        >
                          Apply Scheme:
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            marginBottom: '8px',
                          }}
                          onClick={() => {
                            // If Playbook mode is on, turn it off for ALL tabs to break the global link
                            if (ApplytoAllTabs) {
                              Object.keys(tabState.tabs).forEach((id) =>
                                toggleAllTabs(parseInt(id, 10)),
                              );
                            }
                            // If Tile mode is on, turn it off for just this tab
                            if (ApplytoTiles) toggleAllTiles(selectedTab);
                          }}
                        >
                          <Radio
                            checked={!ApplytoTiles && !ApplytoAllTabs}
                            size="small"
                            style={{ padding: 0, color: '#828383ff' }}
                          />
                          <span style={{ marginLeft: '8px', fontSize: '13px', color: iconColor }}>
                            Current Dashboard only
                          </span>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            marginBottom: '8px',
                          }}
                          onClick={handleTilesCheckboxClick}
                        >
                          <Radio
                            checked={ApplytoTiles && !ApplytoAllTabs}
                            size="small"
                            style={{ padding: 0, color: '#828383ff' }}
                          />
                          <span style={{ marginLeft: '8px', fontSize: '13px', color: iconColor }}>
                            Across Current Tab
                          </span>
                        </div>

                        <div
                          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                          onClick={handlePlaybookCheckboxClick}
                        >
                          <Radio
                            checked={ApplytoAllTabs}
                            size="small"
                            style={{ padding: 0, color: '#828383ff' }}
                          />
                          <span style={{ marginLeft: '8px', fontSize: '13px', color: iconColor }}>
                            Across Entire Playbook
                          </span>
                        </div>
                      </div>
                    </>
                  )}

                  {!isAutoMode && (
                    <div
                      style={{
                        padding: '10px 0.5rem',
                        color: iconColor,
                        fontSize: '13px',
                        border: `1px solid lightgray`,
                        marginTop: '10px',
                        marginRight: '.2rem',
                        marginLeft: '.3rem',
                        borderRadius: '4px',
                      }}
                    >
                      Every tile will bring it's own manual colour selection given at tile level
                      into the dashboard.
                    </div>
                  )}
                </>
              );
            })()}
          </div>
        )}
        {selectedOption === 'resolution' && (
          <div className="resolutionSelector" style={{ marginTop: '-20px' }}>
            <div
              className="optionDescription"
              style={{
                fontSize: '13px',
                color: '#484848',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              <span style={{ color: iconColor, marginLeft: '-3px' }}>Layout:</span>
              <Tooltip
                title="Adjust Dashboard Layout settings"
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '12px',
                    },
                  },
                }}
              >
                <InfoOutlineIcon fontSize="small" style={{ color: iconColor, cursor: 'pointer' }} />
              </Tooltip>
            </div>
            {/* Resolution Type Dropdown */}
            <FormControl
              fullWidth
              size="small"
              style={{
                fontSize: '12px',
                borderRadius: '4px',
                paddingLeft: '4px',
                backgroundColor: tabAreaBackgroundColor,
              }}
            >
              <Select
                value={resolutionType}
                variant="outlined"
                onChange={(e) => {
                  const newResolutionType = e.target.value;
                  dispatch(setResolutionType(selectedTab, newResolutionType));
                  if (tabState.tabs[selectedTab]?.dashboardState?.isCustomLayout) {
                    resetCustomLayout(selectedTab);
                  }

                  if (newResolutionType === 'fixedSize') {
                    dispatch(setResolution(selectedTab, 'HD'));
                    dispatch(setAutoScalingWidth(selectedTab, '1280'));
                    dispatch(setAutoScalingHeight(selectedTab, '720'));
                    updateDashboardDimensions(1280, 720);
                  } else {
                    dispatch(setResolution(selectedTab, ''));

                    const containerWidth = dimensions.width; // container width minus sidebar
                    const initialHeight = dimensions.height; // initial height based on viewport

                    dispatch(setAutoScalingWidth(selectedTab, containerWidth.toString()));
                    dispatch(setAutoScalingHeight(selectedTab, initialHeight.toString()));
                    updateDashboardDimensions(containerWidth, initialHeight);

                    if (newResolutionType === 'autoFit') {
                      handleAutoFitLayout(true);
                    }
                  }
                }}
                sx={{
                  fontSize: '12px',
                  width: '99%',
                  margin: '0 auto 0.5rem auto',
                  backgroundColor: tabAreaBackgroundColor,
                  height: '1.5rem',
                  color: iconColor,
                  textAlign: 'left',
                  '.MuiSelect-icon': { color: iconColor },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'lightgray',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'lightgray',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2bb9bb',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      ml: '.3rem',
                      '& .MuiMenuItem-root.Mui-selected': {
                        backgroundColor: 'rgba(43, 185, 187, 0.1) !important',
                      },
                      '& .MuiMenuItem-root.Mui-selected:hover': {
                        backgroundColor: 'rgba(43, 185, 187, 0.2) !important',
                      },
                    },
                  },
                }}
              >
                <MenuItem value="autoWidth" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                  Scrollable Page
                </MenuItem>
                <MenuItem value="autoFit" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                  Auto Fit
                </MenuItem>
                <MenuItem value="fixedSize" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                  Fixed Size
                </MenuItem>
              </Select>
            </FormControl>

            {/* Auto Width Content */}
            {resolutionType === 'autoWidth' && (
              <div
                className="optionDescription"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'start',
                  marginLeft: '-1px',
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between',
                    marginBottom: '5px',
                  }}
                >
                  <span style={{ color: iconColor }}>Adjust Height:</span>
                  <Tooltip
                    title="Reset to default (32 units)"
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <RestartAltIcon
                      onClick={() => {
                        if (isAtMinRows) return;
                        dispatch(setDashboardRows(selectedTab, 32));
                        const gridUnitY = getAutoWidthRowHeight();
                        const newHeight = gridUnitY * 32;
                        clampElementsInsideDashboard(newHeight);
                      }}
                      style={{
                        cursor: isAtMinRows ? 'default' : 'pointer',
                        marginRight: '.4rem',
                        fontSize: '18px',
                        color: isAtMinRows ? '#ccc' : iconColor,
                        opacity: isAtMinRows ? 0.5 : 1,
                      }}
                    />
                  </Tooltip>
                </div>
                <div
                  // className="optionDescription"
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '25px',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    backgroundColor: tabAreaBackgroundColor,
                    border: `1px solid lightgray`,
                  }}
                >
                  {/* Decrease Button */}
                  <Tooltip
                    title={isAtMinRows ? 'Minimum row limit reached' : 'Decrease Height by 1'}
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <RemoveCircleOutlineOutlinedIcon
                      onClick={handleDecreaseHeight}
                      style={{
                        cursor: isAtMinRows ? 'not-allowed' : 'pointer',
                        fontSize: '16px',
                        color: iconColor,
                        opacity: isAtMinRows ? 0.4 : 1,
                      }}
                    />
                  </Tooltip>

                  {/* Input Field with px label */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: tabAreaBackgroundColor,
                      border: '1px solid #ddd',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: iconColor,
                        userSelect: 'none',
                      }}
                    >
                      {dashboardRows}
                    </span>
                    <span
                      style={{
                        fontSize: '12px',
                        color: iconColor,
                        fontWeight: '500',
                        userSelect: 'none',
                      }}
                    >
                      units
                    </span>
                  </div>

                  {/* Increase Button */}
                  <Tooltip
                    title={isAtMaxRows ? 'Maximum row limit reached' : 'Increase Height by 1'}
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <AddCircleOutlineOutlinedIcon
                      onClick={handleIncreaseHeight}
                      style={{
                        cursor: isAtMaxRows ? 'not-allowed' : 'pointer',
                        fontSize: '18px',
                        color: iconColor,
                        opacity: isAtMaxRows ? 0.4 : 1,
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            )}

            {/* Auto Fit Content */}
            {resolutionType === 'autoFit' && (
              <div style={{ marginTop: '10px', marginLeft: '.3rem' }}>
                <div
                  style={{
                    fontSize: '12px',
                    color: iconColor === '#ffffff' ? '#b9b4b4ff' : '#484848',
                    backgroundColor: tabAreaBackgroundColor,
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                  }}
                >
                  Automatically adjusts the height and width based on the content while maintaining
                  aspect ratio.
                </div>
              </div>
            )}

            {/* Fixed Size Content */}
            {resolutionType === 'fixedSize' && (
              <div style={{ marginTop: '10px' }}>
                <div className="optionDescription" style={{ color: iconColor, marginLeft: '-3px' }}>
                  Resolution :
                </div>
                <FormControl
                  fullWidth
                  size="small"
                  style={{
                    fontSize: '12px',
                    borderRadius: '4px',
                    paddingLeft: '4px',
                    marginBottom: '15px',
                  }}
                >
                  <Select
                    value={resolution}
                    variant="outlined"
                    onChange={(e) => {
                      const newResolution = e.target.value;
                      dispatch(setResolution(selectedTab, newResolution));
                      if (tabState.tabs[selectedTab]?.dashboardState?.isCustomLayout) {
                        resetCustomLayout(selectedTab);
                      }

                      if (newResolution === 'HD') {
                        dispatch(setAutoScalingWidth(selectedTab, '1280'));
                        dispatch(setAutoScalingHeight(selectedTab, '720'));
                        updateDashboardDimensions(1280, 720);
                      } else if (newResolution === 'FULL_HD') {
                        dispatch(setAutoScalingWidth(selectedTab, '1920'));
                        dispatch(setAutoScalingHeight(selectedTab, '1080'));
                        updateDashboardDimensions(1920, 1080);
                      } else if (newResolution === 'CUSTOM') {
                        updateDashboardDimensions(
                          parseInt(autoScalingWidth) || 1280,
                          parseInt(autoScalingHeight) || 720,
                        );
                      }
                    }}
                    sx={{
                      fontSize: '12px',
                      width: '99%',
                      margin: '0 auto 0.5rem auto',
                      backgroundColor: tabAreaBackgroundColor || 'white',
                      height: '1.5rem',
                      color: iconColor,
                      textAlign: 'left',
                      '.MuiSelect-icon': { color: iconColor },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'lightgray',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'lightgray',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          ml: '.6rem',
                          '& .MuiMenuItem-root.Mui-selected': {
                            backgroundColor: 'rgba(43, 185, 187, 0.1) !important',
                          },
                          '& .MuiMenuItem-root.Mui-selected:hover': {
                            backgroundColor: 'rgba(43, 185, 187, 0.2) !important',
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="HD" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                      HD
                    </MenuItem>
                    <MenuItem value="FULL_HD" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                      Full HD
                    </MenuItem>
                    <MenuItem value="CUSTOM" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                      Custom Size
                    </MenuItem>
                  </Select>
                </FormControl>

                {/* Width and Height inputs */}
                <div
                  style={{
                    display: 'flex',
                    gap: '6px',
                    alignItems: 'center',
                    paddingLeft: '0.4rem',
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: '12px',
                        color: iconColor,
                        marginBottom: '5px',
                        textAlign: 'left',
                      }}
                    >
                      Width
                    </div>
                    <input
                      type="number"
                      value={autoScalingWidth}
                      onChange={(e) => {
                        const newWidth = e.target.value;
                        dispatch(setAutoScalingWidth(selectedTab, newWidth));
                        if (tabState.tabs[selectedTab]?.dashboardState?.isCustomLayout) {
                          resetCustomLayout(selectedTab);
                        }

                        if (resolution !== 'CUSTOM') {
                          dispatch(setResolution(selectedTab, 'CUSTOM'));
                        }

                        updateDashboardDimensions(
                          Math.max(parseInt(newWidth) || 0, 800),
                          Math.max(parseInt(autoScalingHeight) || 0, 600),
                        );
                      }}
                      onBlur={() => {
                        const val = parseInt(autoScalingWidth) || 0;
                        if (val < 800) {
                          dispatch(setAutoScalingWidth(selectedTab, '800'));
                          updateDashboardDimensions(
                            800,
                            Math.max(parseInt(autoScalingHeight) || 0, 600),
                          );
                        }
                      }}
                      min="800"
                      style={{
                        width: '100%',
                        height: '1.5rem',
                        fontSize: '12px',
                        padding: '0 8px 0 8px',
                        color: iconColor,
                        backgroundColor: tabAreaBackgroundColor,
                        border: `1px solid ${iconColor}`,
                        borderRadius: '4px',
                        outline: 'none',
                      }}
                      placeholder="px"
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: '12px',
                        color: iconColor,
                        marginBottom: '5px',
                        textAlign: 'left',
                      }}
                    >
                      Height
                    </div>
                    <input
                      type="number"
                      value={autoScalingHeight}
                      onChange={(e) => {
                        const newHeight = e.target.value;
                        dispatch(setAutoScalingHeight(selectedTab, newHeight));
                        if (tabState.tabs[selectedTab]?.dashboardState?.isCustomLayout) {
                          resetCustomLayout(selectedTab);
                        }

                        if (resolution !== 'CUSTOM') {
                          dispatch(setResolution(selectedTab, 'CUSTOM'));
                        }

                        updateDashboardDimensions(
                          Math.max(parseInt(autoScalingWidth) || 0, 800),
                          Math.max(parseInt(newHeight) || 0, 600),
                        );
                      }}
                      onBlur={() => {
                        const val = parseInt(autoScalingHeight) || 0;
                        if (val < 600) {
                          dispatch(setAutoScalingHeight(selectedTab, '600'));
                          updateDashboardDimensions(
                            Math.max(parseInt(autoScalingWidth) || 0, 800),
                            600,
                          );
                        }
                      }}
                      min="600"
                      style={{
                        width: '100%',
                        height: '1.5rem',
                        fontSize: '12px',
                        padding: '0 8px 0 8px',
                        color: iconColor,
                        border: `1px solid ${iconColor}`,
                        backgroundColor: tabAreaBackgroundColor,
                        borderRadius: '4px',
                        outline: 'none',
                      }}
                      placeholder="px"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

  const calculateRequiredDashboardHeight = useCallback(() => {
    const minHeight = getMinDashboardHeight();
    const rowHeight = getAutoWidthRowHeight();

    if (dashboardElements === 0) {
      dispatch(setDashboardRows(selectedTab, 32));
    }

    switch (resolutionType) {
      case 'fixedSize':
        return Math.max(parseInt(autoScalingHeight, 10) || 0, 600);

      case 'autoFit': {
        const gridRows = 32;
        const gridHeightUnit = Math.floor(dimensions.height / gridRows);
        const finalHeight = gridHeightUnit * gridRows;
        return Math.max(finalHeight, minHeight);
      }

      case 'autoWidth': {
        const targetRows = dashboardRows || 32;
        return Math.max(targetRows * rowHeight, minHeight);
      }

      default: {
        return minHeight;
      }
    }
  }, [resolutionType, autoScalingHeight, dashboardElements, dimensions.height, dashboardRows]);
  useEffect(() => {
    if (resolutionType === 'autoWidth' || resolutionType === 'autoFit') {
      const handleResize = () => {
        const newHeight = calculateRequiredDashboardHeight();
        dispatch(setDashboardHeight(selectedTab, newHeight));
      };
      window.addEventListener('resize', handleResize);
      // Clean up the event listener
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [resolutionType, calculateRequiredDashboardHeight, dispatch, selectedTab]);

  useEffect(() => {
    if (dimensions.height > 0) {
      const newHeight = calculateRequiredDashboardHeight();
      dispatch(setDashboardHeight(selectedTab, newHeight));
    }
  }, [resolutionType, calculateRequiredDashboardHeight, dispatch, selectedTab, dimensions.height]);

  useDashboardClipboard();

  const renderElements = () => {
    return (
      <>
        {tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard.map((box, index) => {
          var boxDetails = tabState.tabs[tabTileProps.selectedTabId].dashTilesDetails[box];
          let colorScheme = chartControls.properties[box].colorScheme;
          const isHovered = hoveredTileKey === box;
          const isSelected = selectedTileKey === box;

          if (!ApplytoTiles) {
            colorScheme = scheme_passed;
          }
          return (
            <GraphRNDDash
              key={box}
              softUI={softUI}
              style={softUI ? tileskeuomorphicStyle : ''}
              backgroundColor={backgroundColor}
              colorScheme={colorScheme}
              mouseDownOutsideGraphs={mouseDownOutsideGraphs}
              tabId={tabTileProps.selectedTabId}
              fontFamily={selectedFontFamily}
              boxDetails={boxDetails}
              setShowObjectsSidebar={setShowObjectsSidebar}
              setShowListofTileMenu={setShowListofTileMenu}
              setDashboardResizeColumn={setDashboardResizeColumn}
              setShowDashboardFilterEdit={setShowDashboardFilterEdit}
              propKey={box}
              isHovered={isHovered}
              isSelected={isSelected}
              setStyle={setStyle}
              style2={style2}
              setStyle2={setStyle2}
              dashboardHeight={dashboardHeight}
              dashboardWidth={dimensions.width}
              setMapJSON={setMapJSON}
              setLoading={setLoading}
              isAnyTileInteracting={!!interactingTile}
              setInteractingTile={setInteractingTile}
              // transparentBackgroundColor={!!dashboardBgImage}
            />
          );
        })}
        <Button
          currentTabId={selectedTab}
          selectTile={selectTile}
          dashMode={tabTileProps.dashMode}
          sidebarOpen={sidebarOpen}
          backgroundColor={backgroundColor}
          softUI={softUI}
          colorScheme={color_scheme}
          setSidebarOpen={setSidebarOpen}
          showObjectsSidebar={showObjectsSidebar}
          setShowObjectsSidebar={setShowObjectsSidebar}
          setShowListofTileMenu={setShowListofTileMenu}
          setLayerMode={setLayerMode}
          setDashboardResizeColumn={setDashboardResizeColumn}
          setSelectedObject={setSelectedObject}
          selectTab={selectTab}
          tabState={tabState}
          dashboardHeight={dashboardHeight}
          setShowDashboardFilterEdit={setShowDashboardFilterEdit}
          dashboardWidth={dashStyle.width}
        />
        <Image
          softUI={softUI}
          backgroundColor={backgroundColor}
          colorScheme={color_scheme}
          sidebarOpen={sidebarOpen}
          dashMode={tabTileProps.dashMode}
          currentTabId={selectedTab}
          setSidebarOpen={setSidebarOpen}
          showObjectsSidebar={showObjectsSidebar}
          setShowObjectsSidebar={setShowObjectsSidebar}
          setShowListofTileMenu={setShowListofTileMenu}
          setLayerMode={setLayerMode}
          setDashboardResizeColumn={setDashboardResizeColumn}
          setShowDashboardFilter={setShowDashBoardFilter}
          setSelectedObject={setSelectedObject}
          dashboardHeight={dashboardHeight}
          setShowDashboardFilterEdit={setShowDashboardFilterEdit}
          dashboardWidth={dashStyle.width}
        />

        <RichText
          softUI={softUI}
          backgroundColor={backgroundColor}
          color={iconColor}
          setActiveEditor={setActiveEditor}
          onEditorChange={handleEditorChange}
          colorScheme={color_scheme}
          sidebarOpen={sidebarOpen}
          dashMode={tabTileProps.dashMode}
          currentTabId={selectedTab}
          setSidebarOpen={setSidebarOpen}
          showObjectsSidebar={showObjectsSidebar}
          setShowObjectsSidebar={setShowObjectsSidebar}
          setShowListofTileMenu={setShowListofTileMenu}
          setLayerMode={setLayerMode}
          setDashboardResizeColumn={setDashboardResizeColumn}
          setSelectedObject={setSelectedObject}
          dashboardHeight={dashboardHeight}
          setShowDashboardFilterEdit={setShowDashboardFilterEdit}
          dashboardWidth={dashStyle.width}
        />
      </>
    );
  };
  //There is a seperate container for full screen dashboard canvas before exporting pdf/image and it has a unique id which is used as reference element for exporting.
  return (
    <>
      {fullScreen ? (
        <div id="areaToDownload" className={`${fullScreen && 'fullscreen-section'}`}>
          <div
            className={`${softUI ? 'skeuomorphic' : ''}`}
            // style={{
            //   backgroundColor: backgroundColor,
            //   width: '100vw',
            //   height: '100vh',
            //   border: 'none',
            // }}
          >
            {renderElements()}
          </div>
          <DownloadPagePopover />
        </div>
      ) : (
        <div
          className="dashboardWrapper"
          onMouseDown={(e: any) => {
            var container = 'dragHeader';
            var container2 = 'dashChart';
            var container3 = 'rndObject';

            if (e.target.attributes.class) {
              if (
                e.target.attributes.class.value === container ||
                e.target.attributes.class.value === container2 ||
                e.target.attributes.class.value === container3
              ) {
                setmouseDownOutsideGraphs(false);
              } else {
                setmouseDownOutsideGraphs(true);
              }
            }
          }}
        >
          {tabTileProps.dashMode === 'Present' &&
          iconAlign === 'left' &&
          showDashBoardFilterMenu ? (
            <>
              <div
                className="dashBoardSideBar"
                style={{
                  width: '14rem',
                  backgroundColor: tabAreaBackgroundColor,
                }}
              >
                <ParameterContainer
                  parameterMenu={parameterMenu}
                  setParameterMenu={setParameterMenu}
                  backgroundColor={tabAreaBackgroundColor}
                  color={iconColor}
                />
                <ChartFilterGroupsContainer
                  propKey={'0.0'}
                  fromDashboard={true}
                  reportFilterMenu={reportFilterMenu}
                  setReportFilterMenu={setReportFilterMenu}
                  backgroundColor={tabAreaBackgroundColor}
                  color={iconColor}
                ></ChartFilterGroupsContainer>
              </div>
            </>
          ) : null}
          <div
            className="dashboardOuter"
            ref={targetRef}
            style={{
              backgroundColor: tabAreaBackgroundColor,
              overflowY:
                resolutionType === 'autoFit'
                  ? 'hidden'
                  : tabTileProps.dashMode === 'Present'
                    ? 'auto'
                    : 'auto',
              overflowX:
                resolutionType === 'fixedSize'
                  ? 'auto'
                  : tabTileProps.dashMode === 'Present'
                    ? 'auto'
                    : 'hidden',
            }}
          >
            <div
              id="GraphAreaToDownload"
              className={`dashboardArea ${softUI ? 'skeuomorphic' : ''}`}
              onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                if (e.target === e.currentTarget) {
                  dispatch(setSelectedTile(null));
                }
              }}
              style={{
                '--theme-font': selectedFontFamily,
                ...(tabTileProps.dashMode === 'Edit'
                  ? {
                      ...dashStyle,
                      height: dashboardHeight,
                      backgroundColor: backgroundColor,
                      position: 'relative',
                      width: dashStyle.width,
                      minWidth: dashStyle.width,
                    }
                  : {
                      ...dashStyle1,
                      height:
                        resolutionType === 'autoWidth'
                          ? dashboardHeight
                          : resolutionType === 'fixedSize'
                            ? dashStyle1.height
                            : '100%',
                      width: resolutionType === 'fixedSize' ? dashStyle1.width : '100%',
                      minWidth: resolutionType === 'fixedSize' ? dashStyle1.width : '800px',
                      position: 'relative',
                    }),
              }}
            >
              {dashboardElements > 0 ? (
                renderElements()
              ) : (
                <div
                  id="GraphAreaToDownload"
                  className={softUI ? 'skeuomorphic-inner' : ''}
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#999999',
                    borderTop: pageSettings.callForDownload
                      ? '2px solid rgba(224,224,224,1)'
                      : '0px',
                  }}
                >
                  <pre style={{ fontSize: '16px' }}>
                    {tabTileProps.dashMode === 'Edit'
                      ? `No Visuals Selected`
                      : `No Visuals Selected`}
                  </pre>
                </div>
              )}
            </div>
          </div>
          <ChartData
            tabId={tabTileProps.selectedTabId}
            tileId={tabTileProps.selectedTileId}
            screenFrom="Dashboard"
          ></ChartData>
          {tabTileProps.dashMode === 'Edit' ? (
            <div>
              <ImageUploadModal
                open={showImageUploadModal}
                setSelectedObject={setSelectedObject}
                onClose={() => setShowImageUploadModal(false)}
                tabId={tabTileProps.selectedTabId}
                innerDimensions={innerDimensions}
              />

              {isAnySidebarOpen && (
                <div
                  className="dashBoardSideBar"
                  onMouseDown={(e) => e.stopPropagation()}
                  style={{
                    width: '14rem',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    backgroundColor: tabAreaBackgroundColor,
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      overflowY: 'auto',
                      paddingBottom: '3rem',
                    }}
                  >
                    {showObjectsSidebar && (
                      <div
                        className="chartControlObjectsContainer"
                        style={{ color: iconColor, marginLeft: '-6px' }}
                      >
                        {selectedTileKey ? (
                          <>
                            <div
                              style={{
                                color: ' #404040',
                                fontWeight: '600',
                                padding: '0.5rem 0 0 0.5rem',
                                textAlign: 'start',
                                fontSize: fontSize.large,
                                marginBottom: '0.19rem',
                              }}
                            >
                              <div
                                style={{ display: 'flex', alignItems: 'center', color: iconColor }}
                              >
                                Charts Controls
                                {(() => {
                                  const cType =
                                    chartProperties.properties[selectedTileKey]?.chartType;
                                  const selectedChartData = chartTypes.find(
                                    (c) => c.name === cType,
                                  );
                                  return selectedChartData ? (
                                    <img
                                      src={selectedChartData.icon}
                                      alt={selectedChartData.name}
                                      title={selectedChartData.value}
                                      className="selected-chart-icon"
                                      style={{ paddingLeft: '7px' }}
                                    />
                                  ) : (
                                    <p style={{ display: 'none' }}>
                                      No icon available for the selected chart
                                    </p>
                                  );
                                })()}
                              </div>
                            </div>
                            <ChartControlObjects
                              key={selectedTileKey}
                              fromDashboard={true}
                              iconColor={iconColor}
                              selectedTabBackgroundColor={selectedTabBackgroundColor}
                              backgroundColor={backgroundColor}
                            />
                          </>
                        ) : (
                          <div
                            style={{
                              textAlign: 'center',
                              marginTop: '.7rem',
                              fontSize: '14px',
                              color: iconColor,
                            }}
                          >
                            Please select a tile to view and Change Chart Controls
                          </div>
                        )}
                      </div>
                    )}

                    {showListofTileMenu && (
                      <div className="tileListContainer">
                        <div
                          className="axisTitle"
                          style={{
                            paddingLeft: '0.4rem',
                            marginTop: '.5rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <span
                            style={{
                              fontSize: fontSize.large,
                              color: iconColor,
                              fontWeight: '600',
                            }}
                          >
                            Dashboard Layers
                          </span>
                          <Tooltip
                            title="Hide"
                            slotProps={{
                              tooltip: {
                                sx: { fontSize: '12px' },
                              },
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => setShowListofTileMenu(false)}
                              sx={{ marginRight: '0.3rem' }}
                            >
                              <KeyboardArrowUpIcon sx={{ fontSize: '16px', color: iconColor }} />
                            </IconButton>
                          </Tooltip>
                        </div>

                        <OrientationRadioGroup
                          orientation={layerMode}
                          options={[
                            { name: 'Tiles', key: 'tiles' },
                            { name: 'Objects', key: 'objects' },
                          ]}
                          onChange={(key) => setLayerMode(key as 'tiles' | 'objects')}
                          style={{ margin: '0.5rem 5px 0.5rem 5px', width: 'auto' }}
                        />

                        {layerMode === 'tiles' && (
                          <>
                            <div
                              className="axisTitle"
                              style={{
                                paddingLeft: '0.3rem',
                                paddingTop: 5,
                                paddingBottom: 5,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '0.5rem',
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                <WindowOutlinedIcon sx={{ fontSize: '18px', color: iconColor }} />
                                <span
                                  style={{
                                    fontSize: fontSize.large,
                                    color: iconColor,
                                    fontWeight: 600,
                                  }}
                                >
                                  List of Tiles
                                </span>
                              </div>
                              <Tooltip
                                title={isTilesCollapsed ? 'Expand' : 'Collapse'}
                                slotProps={{
                                  tooltip: {
                                    sx: { fontSize: '12px' },
                                  },
                                }}
                              >
                                <IconButton
                                  size="small"
                                  onClick={() => setIsTilesCollapsed(!isTilesCollapsed)}
                                  sx={{ fontSize: 16, marginRight: '0.2rem' }}
                                >
                                  {isTilesCollapsed ? (
                                    <KeyboardArrowDownIcon
                                      sx={{ fontSize: 16, color: iconColor }}
                                    />
                                  ) : (
                                    <KeyboardArrowUpIcon sx={{ fontSize: 16, color: iconColor }} />
                                  )}
                                </IconButton>
                              </Tooltip>
                            </div>
                            {!isTilesCollapsed && (
                              <div className="tile-list" style={{ color: iconColor }}>
                                {finalTileList}
                              </div>
                            )}
                          </>
                        )}

                        {layerMode === 'objects' && (
                          <DashboardObjects
                            editor={activeEditor}
                            setShowObjectsSidebar={setShowObjectsSidebar}
                            setShowImageUploadModal={setShowImageUploadModal}
                            selectedObject={selectedObject}
                            innerDimensions={innerDimensions}
                            setSelectedObject={setSelectedObject}
                            iconColor={iconColor}
                            backgroundColor={tabAreaBackgroundColor}
                            selectedTabBackgroundColor={selectedTabBackgroundColor}
                          />
                        )}
                      </div>
                    )}

                    {dashboardResizeColumn && (
                      <DashBoardLayoutControl
                        setDashboardResizeColumn={setDashboardResizeColumn}
                        softUISlider={softUISliderComponent}
                        backgroundColor={backgroundColor}
                        setBackgroundColor={setBackgroundColor}
                      />
                    )}

                    {showDashboardFilterEdit && (
                      <div style={{ width: '100%', overflow: 'hidden', paddingRight: '.7rem' }}>
                        <ParameterContainer
                          parameterMenu={parameterMenu}
                          setParameterMenu={setParameterMenu}
                          backgroundColor={tabAreaBackgroundColor}
                          color={iconColor}
                        />
                        <ChartFilterGroupsContainer
                          propKey={'0.0'}
                          fromDashboard={true}
                          reportFilterMenu={reportFilterMenu}
                          setReportFilterMenu={setReportFilterMenu}
                          backgroundColor={tabAreaBackgroundColor}
                          color={iconColor}
                        />
                      </div>
                    )}
                  </div>
                  {/* // Icon button to close sidebar */}
                  <div
                    style={{
                      bottom: '8px',
                      width: '100%',
                      textAlign: 'start',
                    }}
                  >
                    <Tooltip
                      title="Hide Sidebar"
                      slotProps={{
                        tooltip: {
                          sx: { fontSize: '12px' },
                        },
                      }}
                    >
                      <IconButton onClick={handleCollapseSidebar} sx={{ color: iconColor }}>
                        <KeyboardArrowRightIcon fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              )}
            </div>
          ) : null}

          {tabTileProps.dashMode === 'Present' &&
          iconAlign === 'right' &&
          showDashBoardFilterMenu ? (
            <>
              <div
                className="dashBoardSideBar"
                style={{
                  width: '14rem',
                  backgroundColor: tabAreaBackgroundColor,
                  paddingRight: '.7rem',
                }}
              >
                <ParameterContainer
                  parameterMenu={parameterMenu}
                  setParameterMenu={setParameterMenu}
                  backgroundColor={tabAreaBackgroundColor}
                  color={iconColor}
                />
                <ChartFilterGroupsContainer
                  propKey={'0.0'}
                  fromDashboard={true}
                  reportFilterMenu={reportFilterMenu}
                  setReportFilterMenu={setReportFilterMenu}
                  backgroundColor={tabAreaBackgroundColor}
                  color={iconColor}
                ></ChartFilterGroupsContainer>
              </div>
            </>
          ) : null}
        </div>
      )}

      <AcceptRejectDialog
        open={confirmDialog.isOpen}
        heading={confirmDialog.title}
        messages={[{ text: confirmDialog.message }, { text: 'Do you want to proceed?' }]}
        acceptText="Confirm"
        rejectText="Cancel"
        varient="animated"
        rejectButtonStyle={{
          color: 'primary.contrastText',
          hoverColor: 'primary.contrastText',
          padding: '5px 14px',
        }}
        rejectTransition={{
          color: 'primary.contrastText',
          hoverColor: 'primary.contrastText',
          backgroundColor: 'transparent',
          hoverBackgroundColor: '#f0f0f0',
          transitionTime: '0.2s',
        }}
        acceptButtonStyle={{
          border: '1px solid',
          borderColor: 'primary.main',
          color: 'primary.main',
          backgroundColor: 'transparent',
          padding: '5px 14px',
        }}
        acceptTransition={{
          color: 'primary.main',
          hoverColor: 'white',
          backgroundColor: 'transparent',
          hoverBackgroundColor: 'primary.main',
          transitionTime: '0.2s',
        }}
        acceptFunction={handleConfirmAction}
        rejectFunction={handleCloseDialog}
        closeFunction={handleCloseDialog}
      />
    </>
  );
};

const mapStateToProps = (state: DashBoardStateProps & any, ownProps: any) => {
  return {
    chartGroup: state.chartFilterGroup,
    dashBoardGroup: state.dashBoardFilterGroup,
    tabState: state.tabState,
    tabTileProps: state.tabTileProps,
    tileState: state.tileState,
    pageSettings: state.pageSettings,
    chartControls: state.chartControls,
    chartProperties: state.chartProperties,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setTheme: (theme: string, tabId: number) => dispatch(setTheme(theme, tabId)),
    setDashColorScheme: (colorScheme: string, tabId: number) =>
      dispatch(setDashColorScheme(colorScheme, tabId)),
    setThemeId: (themeId: string, tabId: number) => dispatch(setThemeId(themeId, tabId)),
    setTileThemeId: (propKey: string, themeId: string) =>
      dispatch(setTileThemeId(propKey, themeId)),
    toggleAllTiles: (tabId: number) => dispatch(toggleAllTiles(tabId)),
    toggleAllTabs: (tabId: number) => dispatch(toggleAllTabs(tabId)),
    toggleThemeState: (tabId: number) => dispatch(toggleThemeState(tabId)),

    selectTab: (tabName: string, tabId: number, showDash: boolean, dashMode: string) =>
      dispatch(actionsToSelectTab(tabName, tabId, showDash, dashMode)),
    selectTile: (
      tabId: number,
      tileName: string,
      tileId: number,
      nextTileId: number,
      fromTab: boolean,
    ) => dispatch(actionsToUpdateSelectedTile(tabId, tileName, tileId, nextTileId, fromTab)),

    updateGraphHighlight: (tabId: number, propKey: string, highlight: boolean) =>
      dispatch(updateGraphHighlight(tabId, propKey, highlight)),

    updateDashDetails: (
      checked: boolean,
      propKey: string,
      dashSpecs: any,
      tabId: number,
      propIndex: number,
    ) => dispatch(updateTabDashDetails(checked, propKey, dashSpecs, tabId, propIndex)),

    resetCustomLayout: (tabId: number) => dispatch(resetCustomLayout(tabId)),

    toggleGraphSize: (tileKey: string, graphSize: boolean) =>
      dispatch(toggleGraphSize(tileKey, graphSize)),
    graphHighlight: (tabId: number, propKey: string, highlight: boolean | any) =>
      dispatch(updateGraphHighlight(tabId, propKey, highlight)),
    resetHighlight: (tabId: number) => dispatch(resetGraphHighlight(tabId)),
    setGridSize: (gridSize: any) => dispatch(setDashGridSize(gridSize)), //gridSize{ x: null | number | string; y: null | number | string }
    resetPageSettings: () => dispatch(resetPageSettings()), //gridSize{ x: null | number | string; y: null | number | string }
    updateCardControls: (propKey: string, option: string, value: any) =>
      dispatch(updateCardControls(propKey, option, value)),
    updateSankeyStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateSankeyStyleOptions(propKey, option, value)),
    updateGeoChartStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateGeoChartStyleOptions(propKey, option, value)),
    setColorScaleOption: (option: string, value: any, propKey: string) =>
      dispatch(setColorScaleOption(option, value, propKey)),
    setManualColorGauge: (propKey: string, value: any) =>
      dispatch(setManualColorGauge(propKey, value)),
    updateDashBoardGroups: (groupId: string) => dispatch(updateDashBoardGroups(groupId)),
    deleteDashBoardSelectedGroup: (groupId: string) =>
      dispatch(deleteDashBoardSelectedGroup(groupId)),
    deleteDashBoardSelectedGroupAllTabTiles: (groupId: string) =>
      dispatch(deleteDashBoardSelectedGroupAllTabTiles(groupId)),
    addDashBoardFilterGroupTabTiles: (groupId: string) =>
      dispatch(addDashBoardFilterGroupTabTiles(groupId)),
    setDashBoardFilterGroupsTabTiles: (groupId: string, selectedTabTiles: any) =>
      dispatch(setDashBoardFilterGroupsTabTiles(groupId, selectedTabTiles)),
    deleteDashBoardSelectedTabTiles: (groupId: string, selectedTabTiles: any) =>
      dispatch(deleteDashBoardSelectedTabTiles(groupId, selectedTabTiles)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DashBoard);
